export default {
  RIDER_CPR_DESCRIPTION_01:
    'ผลประโยชน์จากสัญญาเพิ่มเติมคุ้มครองโรคมะเร็ง (CPR) รวมสูงสุดโดยแบ่งจ่ายตามระยะของการตรวจพบ ตามรายละเอียดด้านล่าง',
  RIDER_CPR_DISCLAIMER_01: '(ทั้งนี้การจ่ายผลประโยชน์รวมตลอดช่วงอายุจะต้องไม่เกิน 100% ของจำนวนเงินเอาประกันภัย)',
  RIDER_CPR_DESCRIPTION_02:
    '1. ขั้นที่ 1 โรคมะเร็งระยะไม่ลุกลามขั้นต้น หรือ มะเร็งผิวหนัง เฉพาะบาเซล เซล และสแควร์มัส เซล',
  RIDER_CPR_DISCLAIMER_02:
    'การจ่ายผลประโยชน์ดังกล่าวจะเกิดขึ้นก็ต่อเมื่อวันที่เก็บตัวอย่างชิ้นเนื้อเพื่อนำไปตรวจทางพยาธิวิทยาได้พ้นระยะเวลารอคอย 120 วัน***',
  RIDER_CPR_DESCRIPTION_03:
    '2. ขั้นที่ 2 โรคมะเร็งระยะไม่ลุกลาม หรือโรคมะเร็งรังไข่ระยะแรก*\n- สำหรับมะเร็งระยะไม่ลุกลาม หรือโรคมะเร็งรังไข่ระยะแรก',
  RIDER_CPR_DISCLAIMER_03: '',
  RIDER_CPR_DESCRIPTION_04: '- สำหรับมะเร็งปากมดลูก หรือ CIN III',
  RIDER_CPR_DISCLAIMER_04:
    'การจ่ายผลประโยชน์ดังกล่าวจะเกิดขึ้นก็ต่อเมื่อวันที่เก็บตัวอย่างชิ้นเนื้อเพื่อนำไปตรวจทางพยาธิวิทยาได้พ้นระยะเวลารอคอย 90 วัน***',
  RIDER_CPR_DESCRIPTION_05:
    '3. ขั้นที่ 3 โรคมะเร็งระยะไม่ลุกลามของอวัยวะที่กำหนด ที่มีการรักษาโดยการผ่าตัดแบบ Radical surgery*\n- สำหรับโรคมะเร็งระยะไม่ลุกลามของอวัยวะที่กำหนด ที่มีการรักษาโดยการผ่าตัดแบบ Radical surgery',
  RIDER_CPR_DISCLAIMER_05: '',
  RIDER_CPR_DESCRIPTION_06: '- สำหรับกรณีที่มีการเคลมขั้นที่ 2 และต่อมามีการเคลมในขั้นที่ 3 ที่อวัยวะเดิม**',
  RIDER_CPR_DISCLAIMER_06:
    'การจ่ายผลประโยชน์ดังกล่าวจะเกิดขึ้นก็ต่อเมื่อวันที่เก็บตัวอย่างชิ้นเนื้อเพื่อนำไปตรวจทางพยาธิวิทยาได้พ้นระยะเวลารอคอย 90 วัน***',
  RIDER_CPR_DESCRIPTION_07:
    '4. ขั้นที่ 4 โรคมะเร็งระยะลุกลาม รับสูงสุด (หรือ 100% ของจำนวนเงินเอาประกันภัยหักด้วยผลประโยชน์ที่จ่ายมาแล้วทั้งหมด)',
  RIDER_CPR_DISCLAIMER_07:
    'การจ่ายผลประโยชน์ดังกล่าวจะเกิดขึ้นก็ต่อเมื่อวันที่เก็บตัวอย่างชิ้นเนื้อเพื่อนำไปตรวจทางพยาธิวิทยาได้พ้นระยะเวลารอคอย 60 วัน***',

  RIDER_ECARE_DESCRIPTION_01:
    '3. ค่าชดเชยกรณีทุพพลภาพชั่วคราว (ผลประโยชน์ข้อ 3.1 และ 3.2 รวมกันสูงสุดไม่เกิน 52 สัปดาห์)',
  RIDER_ECARE_DESCRIPTION_02: '3.1 ทุพพลภาพสิ้นเชิงชั่วคราว',
  RIDER_ECARE_DESCRIPTION_03: '3.2 ทุพพลภาพบางส่วนชั่วคราว',
  RIDER_ECARE_DESCRIPTION_04:
    '4. ค่าชดเชยกรณีทุพพลภาพถาวรสิ้นเชิง สูงสุดไม่เกิน 100 เดือน โดยมีเงื่อนไขว่าได้จ่ายค่าชดเชยภายใต้ผลประโยชน์ 3. เป็นเวลา 52 สัปดาห์แล้ว',
  RIDER_ECARE_DESCRIPTION_05: '5. ค่าชดเชยกรณีเข้ารักษาตัวในโรงพยาบาลในฐานะคนไข้ใน (สูงสุดไม่เกิน 20 สัปดาห์)',
  RIDER_ECARE_DESCRIPTION_06: '6. ค่ารักษาพยาบาลเนื่องจากอุบัติเหตุ* ตามที่จ่ายจริง แต่ไม่เกิน',
  RIDER_ECARE_DISCLAIMER_01: '',
  RIDER_ECARE_DISCLAIMER_02: '*ค่ารักษาพยาบาลรวมถึง ค่ายา ค่าโรงพยาบาล ค่าธรรมเนียมแพทย์',

  RIDER_AP_ECARE_NAME: 'AP และ ECARE',
  RIDER_AP_ECARE_DESCRIPTION_01: '1. กรณีเสียชีวิต สูญเสียอวัยวะ และสายตา',
  RIDER_AP_ECARE_DESCRIPTION_02: 'เสียชีวิต',
  RIDER_AP_ECARE_DESCRIPTION_03: 'สูญเสียมือหรือเท้า 1 ข้างหรือมากกว่า',
  RIDER_AP_ECARE_DESCRIPTION_04: 'สูญเสียสายตา 1 ข้างหรือมากกว่า',
  RIDER_AP_ECARE_DESCRIPTION_05: 'สูญเสียการได้ยิน',
  RIDER_AP_ECARE_DESCRIPTION_06: 'ทั้งสองข้าง',
  RIDER_AP_ECARE_DESCRIPTION_07: 'ข้างเดียว',
  RIDER_AP_ECARE_DESCRIPTION_08: 'สูญเสียการพูด',
  RIDER_AP_ECARE_DESCRIPTION_09: 'สูญเสียแก้วตาทั้งสองข้าง',
  RIDER_AP_ECARE_DESCRIPTION_10: 'สูญเสียนิ้วมือทั้ง 4 และนิ้วหัวแม่มือ',
  RIDER_AP_ECARE_DESCRIPTION_11: 'มือขวา',
  RIDER_AP_ECARE_DESCRIPTION_12: 'มือซ้าย',
  RIDER_AP_ECARE_DESCRIPTION_13: 'สูญเสียนิ้วมือทั้ง 4 นิ้ว',
  RIDER_AP_ECARE_DESCRIPTION_14: 'มือขวา',
  RIDER_AP_ECARE_DESCRIPTION_15: 'มือซ้าย',
  RIDER_AP_ECARE_DESCRIPTION_16: 'กระดูกขา หรือสะบ้า แตกหัก',
  RIDER_AP_ECARE_DESCRIPTION_17: 'ขาหดสั้นลงอย่างน้อย 5 เซนติเมตร',
  RIDER_AP_ECARE_DESCRIPTION_18: 'สูญเสียนิ้วหัวแม่มือ',
  RIDER_AP_ECARE_DESCRIPTION_19: 'นิ้วหัวแม่มือขวาทั้งสองข้อ',
  RIDER_AP_ECARE_DESCRIPTION_20: 'นิ้วหัวแม่มือขวาหนึ่งข้อ',
  RIDER_AP_ECARE_DESCRIPTION_21: 'นิ้วหัวแม่มือซ้ายทั้งสองข้อ',
  RIDER_AP_ECARE_DESCRIPTION_22: 'นิ้วหัวแม่มือซ้ายหนึ่งข้อ',
  RIDER_AP_ECARE_DESCRIPTION_23: 'สูญเสียนิ้วมืออื่นๆ',
  RIDER_AP_ECARE_DESCRIPTION_24: 'นิ้วมือขวา นิ้วใดนิ้วหนึ่งทั้งสามข้อ',
  RIDER_AP_ECARE_DESCRIPTION_25: 'นิ้วมือขวา นิ้วใดนิ้วหนึ่งสองข้อ',
  RIDER_AP_ECARE_DESCRIPTION_26: 'นิ้วมือขวา นิ้วใดนิ้วหนึ่งข้อเดียว',
  RIDER_AP_ECARE_DESCRIPTION_27: 'นิ้วมือซ้าย นิ้วใดนิ้วหนึ่งทั้งสามข้อ',
  RIDER_AP_ECARE_DESCRIPTION_28: 'นิ้วมือซ้าย นิ้วใดนิ้วหนึ่งทั้งสองข้อ',
  RIDER_AP_ECARE_DESCRIPTION_29: 'นิ้วมือซ้าย นิ้วใดนิ้วหนึ่งข้อเดียว',
  RIDER_AP_ECARE_DESCRIPTION_30: 'สูญเสียนิ้วเท้า',
  RIDER_AP_ECARE_DESCRIPTION_31: 'นิ้วเท้าหมดทุกนิ้ว 1 เท้า',
  RIDER_AP_ECARE_DESCRIPTION_32: 'นิ้วหัวแม่เท้าทั้งนิ้ว',
  RIDER_AP_ECARE_DESCRIPTION_33: 'นิ้วหัวแม่เท้าหนึ่งข้อ',
  RIDER_AP_ECARE_DESCRIPTION_34: 'กรณีเสียชีวิต ผลประโยชน์เป็น 2 เท่าหากอุบัติเหตุเกิดจากสาธารณภัย',
  RIDER_AP_ECARE_DESCRIPTION_35: '2. กรณีมีบาดแผลจากการไฟไหม้',
  RIDER_AP_ECARE_DESCRIPTION_36: 'ศีรษะ',
  RIDER_AP_ECARE_DESCRIPTION_37: 'มากกว่าหรือเท่ากับ 2% แต่น้อยกว่า 4%',
  RIDER_AP_ECARE_DESCRIPTION_38: 'มากกว่าหรือเท่ากับ 4% แต่น้อยกว่า 6%',
  RIDER_AP_ECARE_DESCRIPTION_39: 'มากกว่าหรือเท่ากับ 6% แต่น้อยกว่า 8%',
  RIDER_AP_ECARE_DESCRIPTION_40: 'เท่ากับหรือมากกว่า 8%',
  RIDER_AP_ECARE_DESCRIPTION_41: 'ร่างกาย',
  RIDER_AP_ECARE_DESCRIPTION_42: 'มากกว่าหรือเท่ากับ 10% แต่น้อยกว่า 12.5%',
  RIDER_AP_ECARE_DESCRIPTION_43: 'มากกว่าหรือเท่ากับ 12.5% แต่น้อยกว่า 15%',
  RIDER_AP_ECARE_DESCRIPTION_44: 'มากกว่าหรือเท่ากับ 15% แต่น้อยกว่า 20%',
  RIDER_AP_ECARE_DESCRIPTION_45: 'เท่ากับหรือมากกว่า 20%',
  RIDER_ESCI_RIDER_BENEFIT_TITLE:
    'สัญญาเพิ่มเติมโรคร้ายแรงคุ้มครองเริ่มต้น และ สัญญาเพิ่มเติมผลประโยชน์ยกเว้นเบี้ยประกันภัยสัญญาหลักเนื่องจากโรคร้ายแรง',
  RIDER_ESCI_2020_RIDER_BENEFIT_TITLE:
    'สัญญาเพิ่มเติมโรคร้ายแรงคุ้มครองเริ่มต้น (ESCI) และ สัญญาเพิ่มเติมผลประโยชน์ยกเว้นเบี้ยประกันภัยสัญญาหลัก เนื่องจากโรคร้ายแรง 2020 (WPE)',
  RIDER_ESCI_DESCRIPTION_01:
    '1. ความคุ้มครองของโรคร้ายแรง 5 กลุ่มโรค ได้แก่ มะเร็ง อวัยวะสำคัญ ระบบประสาท หัวใจ และ โรคร้ายแรงอื่นๆ ตามที่กรมธรรม์กำหนด ซึ่งไม่ได้อยู่ใน 4 กลุ่มแรก',
  RIDER_ESCI_DESCRIPTION_02:
    'โดยการวินิจฉัยว่าเป็นโรคร้ายแรงตามที่กำหนด จะต้องเกิดขึ้นในขณะที่ผู้เอาประกันภัยมีชีวิตอยู่ และกรมธรรม์มีผลบังคับ',
  RIDER_ESCI_DESCRIPTION_03: 'ความคุ้มครองในแต่ละระยะความรุนแรงของแต่ละกลุ่มโรค',
  RIDER_ESCI_DESCRIPTION_04: '1.1 ระยะเริ่มต้น (สูงสุด ต่อโรค)',
  RIDER_ESCI_DESCRIPTION_05: '1.2 ระยะปานกลาง (สูงสุด ต่อโรค)',
  RIDER_ESCI_DESCRIPTION_06: '1.3 ระยะรุนแรง (สูงสุด ต่อโรค)',
  RIDER_ESCI_DESCRIPTION_07: 'รวมผลประโยชน์สูงสุดในแต่ละกลุ่มโรค ไม่เกิน',
  RIDER_ESCI_DESCRIPTION_08: 'รวมผลประโยชน์สูงสุดในการเคลมจาก 5 กลุ่มโรค ไม่เกิน',
  RIDER_ESCI_DESCRIPTION_09:
    'ผลประโยชน์เพิ่มเติม 10 โรคสำหรับผู้เอาประกันภัย อายุ 1 เดือน - 18 ปี (ความคุ้มครองจะสิ้นสุดลง ณ อายุ 18 ปี)',
  RIDER_ESCI_DESCRIPTION_10: 'รวมผลประโยชน์สูงสุดของสัญญาเพิ่มเติม',
  RIDER_ESCI_DESCRIPTION_11: 'ผลประโยชน์พิเศษ',
  RIDER_ESCI_VALUE_11:
    'บริษัทฯ จะจ่ายเบี้ยประกันให้แผนประกัน iCare เพื่อให้กรมธรรม์ยังคงมีผลบังคับต่อไป กรณีตรวจพบโรคร้ายแรงระยะรุนแรงในกลุ่มโรคใดกลุ่มโรคหนึ่ง',
  RIDER_ESCI_VALUE_12:
    'บริษัทฯ จะจ่ายเบี้ยประกันให้แผนประกัน iCare เพื่อให้กรมธรรม์ยังคง \n มีผลบังคับต่อไป กรณีตรวจพบโรคร้ายแรงระยะรุนแรงครั้งแรก \n ในกลุ่มโรคใดกลุ่มโรคหนึ่ง',

  EXCEPTION_NOTED_AP_ECARE: {
    title: [
      'ไม่คุ้มครองการเสียชีวิตและการสูญเสียอวัยวะ อันเกิดจากสาเหตุดังต่อไปนี้',
      'ไม่คุ้มครองการเสียชีวิต การสูญเสียอวัยวะ การทุพพลภาพ และการรักษาพยาบาล อันเกิดจากสาเหตุดังต่อไปนี้',
    ],
    exceptions: [
      'ข้อยกเว้นสัญญาเพิ่มเติมการประกันภัยอุบัติเหตุ คุ้มครองการเสียชีวิต และสูญเสียอวัยวะ (AP) มีทั้งหมด 11 ข้อ',
      'ข้อยกเว้นสัญญาเพิ่มเติมการประกันภัยอุบัติเหตุ คุ้มครองการเสียชีวิต สูญเสียอวัยวะ และค่ารักษาพยาบาล (ECARE) มีทั้งหมด 12 ข้อ เช่น',
      [
        'การการฆ่าตัวตายหรือการทำร้ายร่างกายตนเอง',
        'การกระทำขณะอยู่ภายใต้ฤทธิ์สุรา ยาเสพติด หรือสารเสพติดให้โทษจนไม่สามารถครองสติได้ คำว่า “ขณะอยู่ภายใต้ฤทธิ์สุรา” นั้น ในกรณีที่มีการตรวจเลือดให้ถือเกณฑ์มีระดับแอลกอฮอล์ในเลือดตั้งแต่ 150 มิลลิกรัมเปอร์เซ็นต์ ขึ้นไป',
        'ขณะที่ผู้เอาประกันภัยเข้าร่วมทะเลาะวิวาท หรือมีส่วนยั่วยุให้เกิดการทะเลาะวิวาท',
        'การแท้งลูก',
        'ขณะขึ้นหรือลง หรือเป็นผู้ขับขี่ หรืออยู่ในอากาศยานใด ๆ ไม่ว่าจะขับเคลื่อนด้วยตัวของมันเองหรือไม่ก็ตามที่มิได้จดทะเบียนประกอบการบินพาณิชย์',
      ],
    ],
    condition:
      'ทั้งนี้ หากพบว่าผู้ขอเอาประกันภัยมีอาชีพข้างต้น ให้ระบุในใบคำขอเอาประกันชีวิต ข้อ 21 (หมายเหตุ) หรือในใบคำร้อง UW06 ว่า “ยินยอมไม่คุ้มครองการจลาจล ฆาตกรรม ลอบทำร้าย และสงครามกลางเมือง” ภายใต้สัญญาเพิ่มเติม ',
  },
  EXCEPTION_NOTED_HIC: {
    title:
      'ข้อยกเว้นสัญญาเพิ่มเติมค่าชดเชยรายวันเนื่องจากโรคมะเร็ง (HIC) มีทั้งหมด 16 ข้อ เช่น\nไม่คุ้มครองการรักษาพยาบาล หรือความเสียหายที่เกิดจากการบาดเจ็บหรือเจ็บป่วย อันเนื่องมาจากสาเหตุ ดังต่อไปนี้',
    exceptions: [
      'โรคเรื้อรัง การเจ็บป่วยที่ยังมิได้รักษาให้หายก่อนวันทำสัญญาประกันภัย การตรวจรักษาภาวะที่เป็นมาแต่กำเนิด (Congenital) หรือโรคทางพันธุกรรม',
      'การติดเชื้อไวรัสภูมิคุ้มกันบกพร่อง (HIV Positive) หรือภาวะโรคภูมิคุ้มกันบกพร่อง (AIDS) ของผู้เอาประกันภัย',
      'ผู้เอาประกันภัยปฏิเสธไม่ยอมรับการรักษา แนะนำ หรือ ปฏิบัติตามคำแนะนำของแพทย์',
      'โรคมะเร็งที่มิได้เป็นไปตามคำนิยามของสัญญาเพิ่มเติมนี้',
      'การตรวจรักษาพยาบาลที่ผู้เอาประกันภัย ซึ่งเป็นแพทย์สั่งให้แก่ตัวเอง รวมทั้งการตรวจรักษาพยาบาลจากแพทย์ ผู้ซึ่งเป็นบิดา มารดา คู่สมรส หรือบุตรของผู้เอาประกันภัย',
    ],
    condition: '',
  },
  EXCEPTION_NOTED_CPR: {
    title:
      'ข้อยกเว้นสัญญาเพิ่มเติมคุ้มครองโรคมะเร็ง (CPR) มีทั้งหมด 10 ข้อ เช่น\nไม่คุ้มครองการเจ็บป่วยด้วยโรคมะเร็ง อันเนื่องมาจากสาเหตุ ดังต่อไปนี้',
    exceptions: [
      'โรคเรื้อรัง การเจ็บป่วยที่ยังมิได้รักษาให้หายก่อนวันเริ่มมีผลคุ้มครอง การตรวจรักษาภาวะที่เป็นมาแต่กำเนิด (Congenital) หรือโรคทางพันธุกรรม',
      'การติดเชื้อไวรัสภูมิคุ้มกันบกพร่อง (HIV Positive) หรือภาวะโรคภูมิคุ้มกันบกพร่อง (AIDS) ของผู้เอาประกันภัย',
      'ผู้เอาประกันภัยปฏิเสธไม่ยอมรับการรักษา แนะนำ หรือ ปฏิบัติตามคำแนะนำของแพทย์',
      'โรคมะเร็งที่มิได้เป็นไปตามคำนิยามของสัญญาเพิ่มเติมนี้',
      'การก่อการร้าย',
    ],
    condition: '',
  },
  EXCEPTION_NOTED_MEAPLUS: {
    title: '',
    exceptions: [
      'ข้อยกเว้นสัญญาเพิ่มเติมค่ารักษาพยาบาล (พิเศษ) (MEA+) มีทั้งหมด 17 ข้อ เช่น',
      [
        'สัญญาเพิ่มเติมนี้ไม่คุ้มครองการรักษาพยาบาล หรือความเสียหายที่เกิดจากการบาดเจ็บหรือเจ็บป่วย (รวมทั้งโรคแทรกซ้อน) อาการ หรือภาวะความผิดปกติที่เกิดจาก',
        [
          'โรคเรื้อรัง การเจ็บป่วยหรือการบาดเจ็บที่ยังมิได้รักษาให้หายก่อนวันทำสัญญาประกันภัย การตรวจรักษาภาวะที่เป็นมาแต่กำเนิด (Congenital) หรือปัญหาด้านพัฒนาการ หรือโรคทางพันธุกรรม',
          'การตรวจรักษาหรือการผ่าตัดเพื่อเสริมสวย หรือการแก้ไขปัญหาผิวพรรณ สิว ฝ้า กระ รังแค ผมร่วง หรือการควบคุมน้ำหนักตัว หรือการผ่าตัดอันมีลักษณะเลือกได้ เว้นแต่เป็นการตกแต่งบาดแผลอันเนื่องมาจากอุบัติเหตุที่ได้รับความคุ้มครอง',
          'การตั้งครรภ์ แท้งบุตร ทำแท้ง การคลอดบุตร โรคแทรกซ้อนจากการตั้งครรภ์ การแก้ไขปัญหาการมีบุตรยาก (รวมถึงการสืบวิเคราะห์และการรักษา) การทำหมันหรือการคุมกำเนิด',
          'โรคเอดส์ หรือกามโรค หรือโรคติดต่อทางเพศสัมพันธ์',
          'การตรวจรักษา หรือการป้องกัน การใช้ยา หรือสารต่างๆ เพื่อการชะลอความเสื่อมของวัย หรือการให้ฮอร์โมนทดแทนในวัยใกล้หมดหรือหมดระดู การเสื่อมสมรรถภาพทางเพศในหญิงหรือชาย การรักษาความผิดปกติทางเพศ และการแปลงเพศ',
        ],
      ],
    ],
    condition: '',
  },
  EXCEPTION_NOTED_MEX: {
    title: 'เงื่อนไขที่สำคัญ และข้อยกเว้นสำหรับสัญญาเพิ่มเติมค่ารักษาพยาบาล เอ็กซ์ตร้า (MEX)',
    exceptions: [
      'การต่ออายุสัญญาเพิ่มเติมกรณีครบรอบปีกรมธรรม์ประกันภัย (Renewal)',
      'สัญญาเพิ่มเติมค่ารักษาพยาบาล เอ็กซ์ตร้า (MEX) สามารถต่ออายุได้ถึงอายุ 89 ปี ทั้งนี้ ต้องไม่เกินระยะเวลาเอาประกันภัยของกรมธรรม์\nประกันชีวิตที่สัญญาเพิ่มเติมนี้แนบท้ายอยู่และในการต่ออายุสัญญาเพิ่มเติมนี้ บริษัทจะสงวนสิทธิในการเปลี่ยนแปลงเงื่อนไขข้อตกลงความคุ้มครอง โดยการเพิ่มเงื่อนไขให้ผู้เอาประกันภัยมีค่าใช้จ่ายร่วม (Copayment) ตามอัตราและหลักเกณฑ์ดังต่อไปนี้',
      [
        'อัตราร้อยละ 30 ของค่าใช้จ่ายที่ได้รับความคุ้มครอง กรณีผู้เอาประกันภัยมีการเรียกร้องผลประโยชน์จากการป่วยเล็กน้อยทั่วไป (Simple diseases) และเข้าพักรักษาตัวในโรงพยาบาล ในรอบปีกรมธรรม์ประกันภัยตั้งแต่ 3 ครั้งขึ้นไป และมีอัตราการเรียกร้องค่าสินไหมทดแทน\nจากสาเหตุข้างต้นของผู้เอาประกันภัยแต่ละรายภายใต้สัญญาเพิ่มเติมฉบับนี้ ตั้งแต่ร้อยละ 200 หรือ',
        'อัตราร้อยละ 30 ของค่าใช้จ่ายที่ได้รับความคุ้มครอง กรณีผู้เอาประกันภัยมีการเรียกร้องผลประโยชน์จากการเข้าพักรักษาตัวในโรงพยาบาล ในรอบปีกรมธรรม์ประกันภัยตั้งแต่ 3 ครั้งขึ้นไป และมีอัตราการเรียกร้องค่าสินไหมทดแทนจากสาเหตุข้างต้นของผู้เอาประกันภัยแต่ละราย\nภายใต้สัญญาเพิ่มเติมฉบับนี้ ตั้งแต่ร้อยละ 400 แต่ไม่รวมถึงค่าสินไหมทดแทนจากค่ารักษาโรคร้ายแรงตามรายชื่อในเอกสารแนบท้ายรายชื่อ\nโรคร้ายแรง และ/หรือการผ่าตัดใหญ่',
        'หากบริษัทเพิ่มเงื่อนไขให้ผู้เอาประกันภัยมีค่าใช้จ่ายร่วม (Copayment) เนื่องจากมีกรณีตาม (1) และ (2) บริษัทจะกำหนดเงื่อนไขให้ผู้เอาประกันภัย\nมีค่าใช้จ่ายร่วม (Copayment) ร้อยละ 50 ของค่าใช้จ่ายที่ได้รับความคุ้มครอง ในกรณีที่บริษัทกำหนดเงื่อนไขให้ผู้เอาประกันภัยมีค่าใช้จ่ายร่วม \n(Copayment) แล้ว ต่อมาการเรียกร้องผลประโยชน์หรืออัตราการเรียกร้องค่าสินไหมทดแทนของผู้เอาประกันภัยปรับลดลงจากหลักเกณฑ์ข้างต้น\nให้บริษัทพิจารณาปรับลดอัตราค่าใช้จ่ายร่วม (Copayment) ให้กับผู้เอาประกันภัย',
        'ในกรณีบริษัทเพิ่มเติมเงื่อนไขให้ผู้เอาประกันภัยมีค่าใช้จ่ายร่วม (Copayment) ที่เป็นไปตามอัตราและหลักเกณฑ์ข้างต้น บริษัทจะออกหลักฐาน\nเกี่ยวกับการกำหนดอัตราและหลักเกณฑ์ค่าใช้จ่ายร่วม (Copayment) ให้ผู้เอาประกันภัยทราบก่อนวันครบรอบปีกรมธรรม์ประกันภัย ไม่น้อยกว่า 15 วัน',
      ],
      'เงื่อนไขที่สำคัญ กรณีที่บริษัทจะไม่คุ้มครอง เนื่องจาก',
      'การป่วยที่เกิดขึ้นในระยะเวลาที่ไม่คุ้มครอง (Waiting Period) 30 วัน นับแต่วันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือวันที่บริษัทอนุมัติให้เพิ่มผลประโยชน์ของสัญญาเพิ่มเติมนี้ แล้วแต่กรณีใดจะเกิดขึ้นภายหลังหรือ',
      [
        'การป่วยดังต่อไปนี้ ที่เกิดขึ้นในระยะเวลาที่ไม่คุ้มครอง (Waiting Period) 120 วัน นับแต่วันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือวันที่บริษัทอนุมัติให้เพิ่มผลประโยชน์ของสัญญาเพิ่มเติมนี้ แล้วแต่กรณีใดจะเกิดขึ้นภายหลัง',
        [
          'เนื้องอก ถุงน้ำ หรือมะเร็งทุกชนิด',
          'ไส้เลื่อนทุกชนิด',
          'การตัดทอนซิล หรืออดีนอยด์',
          'เส้นเลือดขอดที่ขา',
          'ริดสีดวงทวาร',
          'ต้อเนื้อ หรือต้อกระจก',
          'นิ่วทุกชนิด',
          'เยื่อบุโพรงมดลูกเจริญผิดที่',
        ],
      ],
      [
        'สภาพที่เป็นมาก่อนการเอาประกันภัย (Pre-existing Condition)',
        'บริษัทจะไม่จ่ายผลประโยชน์ตามสัญญาเพิ่มเติมนี้ สำหรับโรคเรื้อรัง การบาดเจ็บ หรือการป่วย (รวมถึงภาวะแทรกซ้อน) ที่ยังมิได้รักษาให้หายก่อนวันที่สัญญาเพิ่มเติมนี้เริ่มมีผลคุ้มครองเป็นครั้งแรก เว้นแต่',
        [
          'ผู้เอาประกันภัยได้แถลงให้บริษัททราบ และบริษัทยินยอมรับความเสี่ยงภัย โดยไม่มีเงื่อนไขยกเว้นความคุ้มครองดังกล่าว หรือ',
          'โรคเรื้อรัง การบาดเจ็บ หรือการป่วย (รวมถึงภาวะแทรกซ้อน) นั้น ไม่ปรากฏอาการ ไม่ได้รับการตรวจรักษาหรือวินิจฉัยโดยแพทย์ หรือไม่ได้พบหรือปรึกษาแพทย์ ในระยะ 5 ปี ก่อนวันที่สัญญาเพิ่มเติมเริ่มมีผลคุ้มครองเป็นครั้งแรก และในช่วงเวลา 3 ปี ตั้งแต่วันที่สัญญาเพิ่มเติมนี้เริ่มมีผลคุ้มครองเป็นครั้งแรก',
        ],
      ],
      'ข้อยกเว้นทั่วไป',
      [
        'ข้อยกเว้นสัญญาเพิ่มเติมค่ารักษาพยาบาล เอ็กซ์ตร้า (MEX) มีทั้งหมด 21 ข้อ ตัวอย่างเช่น',
        'การประกันภัยนี้ไม่คุ้มครองค่าใช้จ่ายจากการรักษาพยาบาล หรือความเสียหายที่เกิดจากการบาดเจ็บหรือการป่วย (รวมทั้งภาวะแทรกซ้อน) อาการ หรือภาวะความผิดปกติที่เกิดจาก',
        [
          'ภาวะที่เป็นผลจากความผิดปกติที่เกิดขึ้นแต่กำเนิด หรือระบบการสร้างอวัยวะของร่างกายไม่สมบูรณ์แต่กำเนิด หรือโรคทางพันธุกรรม หรือความผิดปกติในการพัฒนาการของร่างกาย เว้นแต่ สัญญาเพิ่มเติมนี้มีผลคุ้มครองมาไม่น้อยกว่า 1 ปี และปรากฏอาการหลังผู้เอาประกันภัยมีอายุครบ 16 ปีบริบูรณ์',
          'การตรวจรักษาหรือการผ่าตัดเพื่อเสริมสวย หรือการแก้ไขปัญหาผิวพรรณ สิว ฝ้า กระ รังแค ผมร่วงหรือการควบคุมน้ำหนักตัว การผ่าตัดที่สามารถทดแทนด้วยการรักษาแนวทางอื่น เว้นแต่เป็นการตกแต่งบาดแผลอันเนื่องมาจากอุบัติเหตุที่ได้รับความคุ้มครอง',
          'โรคเอดส์ หรือกามโรค หรือโรคติดต่อทางเพศสัมพันธ์',
          'การฆ่าตัวตาย การพยายามฆ่าตัวตาย การทำร้ายร่างกายตนเอง หรือการพยายามทำร้ายร่างกายตนเองไม่ว่าจะเป็นการกระทำโดยตนเอง หรือยินยอมให้ผู้อื่นกระทำไม่ว่าจะอยู่ในระหว่างวิกลจริตหรือไม่ก็ตาม ทั้งนี้รวมถึงอุบัติเหตุจากการที่ผู้เอาประกันภัย กิน ดื่ม หรือฉีดยาหรือสารมีพิษเข้าร่างกาย การใช้ยาเกินกว่าที่แพทย์สั่ง',
          'การบาดเจ็บที่เกิดขึ้นอันเป็นผลมาจากการกระทำของผู้เอาประกันภัย ',
        ],
        [
          'ขณะอยู่ภายใต้ฤทธิ์สารเสพติด หรือยาเสพติดให้โทษจนไม่สามารถครองสติได้ หรือ',
          'ขณะอยู่ภายใต้ฤทธิ์สุราโดยมีระดับแอลกอฮอล์ในร่างกายขณะตรวจเทียบเท่ากับระดับแอลกอฮอล์ในเลือด ตั้งแต่ 150 มิลลิกรัมเปอร์เซ็นต์ขึ้นไป หรือ',
          'ขณะอยู่ภายใต้ฤทธิ์สุราจนไม่สามารถครองสติได้ ในกรณีที่ไม่มีการตรวจวัดหรือในกรณีที่ไม่สามารถตรวจวัด ระดับแอลกอฮอล์ได้',
        ],
      ],
    ],
    condition: '',
  },
  EXCEPTION_NOTED_MHP: {
    title: 'เงื่อนไขที่สำคัญ และข้อยกเว้นสำหรับสัญญาเพิ่มเติมค่ารักษาพยาบาล ไอเฮลท์ตี้ อัลตร้า (MHP)',
    exceptions: [
      'การต่ออายุสัญญาเพิ่มเติมกรณีครบรอบปีกรมธรรม์ประกันภัย (Renewal)',
      'สัญญาเพิ่มเติมค่ารักษาพยาบาล ไอเฮลท์ตี้ อัลตร้า (MHP) สามารถต่ออายุได้ถึงอายุ 98 ปี ทั้งนี้ ต้องไม่เกินระยะเวลาเอาประกันภัยของกรมธรรม์\nประกันชีวิตที่สัญญาเพิ่มเติมนี้แนบท้ายอยู่และในการต่ออายุสัญญาเพิ่มเติมนี้ บริษัทจะสงวนสิทธิในการเปลี่ยนแปลงเงื่อนไขข้อตกลงความคุ้มครอง โดยการเพิ่มเงื่อนไขให้ผู้เอาประกันภัยมีค่าใช้จ่ายร่วม (Copayment) ตามอัตราและหลักเกณฑ์ดังต่อไปนี้',
      [
        'อัตราร้อยละ 30 ของค่าใช้จ่ายที่ได้รับความคุ้มครอง กรณีผู้เอาประกันภัยมีการเรียกร้องผลประโยชน์จากการป่วยเล็กน้อยทั่วไป (Simple diseases) และเข้าพักรักษาตัวในโรงพยาบาล ในรอบปีกรมธรรม์ประกันภัยตั้งแต่ 3 ครั้งขึ้นไป และมีอัตราการเรียกร้องค่าสินไหมทดแทน\nจากสาเหตุข้างต้นของผู้เอาประกันภัยแต่ละรายภายใต้สัญญาเพิ่มเติมฉบับนี้ ตั้งแต่ร้อยละ 200 หรือ',
        'อัตราร้อยละ 30  ของค่าใช้จ่ายที่ได้รับความคุ้มครอง กรณีผู้เอาประกันภัยมีการเรียกร้องผลประโยชน์จากการเข้าพักรักษาตัวในโรงพยาบาล ในรอบปีกรมธรรม์ประกันภัยตั้งแต่ 3 ครั้งขึ้นไป และมีอัตราการเรียกร้องค่าสินไหมทดแทนจากสาเหตุข้างต้นของผู้เอาประกันภัยแต่ละราย\nภายใต้สัญญาเพิ่มเติมฉบับนี้ ตั้งแต่ร้อยละ 400 แต่ไม่รวมถึงค่าสินไหมทดแทนจากค่ารักษาโรคร้ายแรงตามรายชื่อในเอกสารแนบท้ายรายชื่อ\nโรคร้ายแรง และ/หรือการผ่าตัดใหญ่',
        'หากบริษัทเพิ่มเงื่อนไขให้ผู้เอาประกันภัยมีค่าใช้จ่ายร่วม (Copayment) เนื่องจากมีกรณีตาม (1) และ (2) บริษัทจะกำหนดเงื่อนไขให้ผู้เอาประกันภัย\nมีค่าใช้จ่ายร่วม (Copayment) ร้อยละ 50 ของค่าใช้จ่ายที่ได้รับความคุ้มครอง ในกรณีที่บริษัทกำหนดเงื่อนไขให้ผู้เอาประกันภัยมีค่าใช้จ่ายร่วม \n(Copayment) แล้ว ต่อมาการเรียกร้องผลประโยชน์หรืออัตราการเรียกร้องค่าสินไหมทดแทนของผู้เอาประกันภัยปรับลดลงจากหลักเกณฑ์ข้างต้น\nให้บริษัทพิจารณาปรับลดอัตราค่าใช้จ่ายร่วม (Copayment) ให้กับผู้เอาประกันภัย',
        'ในกรณีบริษัทเพิ่มเติมเงื่อนไขให้ผู้เอาประกันภัยมีค่าใช้จ่ายร่วม (Copayment) ที่เป็นไปตามอัตราและหลักเกณฑ์ข้างต้น บริษัทจะออกหลักฐาน\nเกี่ยวกับการกำหนดอัตราและหลักเกณฑ์ค่าใช้จ่ายร่วม (Copayment) ให้ผู้เอาประกันภัยทราบก่อนวันครบรอบปีกรมธรรม์ประกันภัย ไม่น้อยกว่า 15 วัน',
      ],
      'เงื่อนไขที่สำคัญ กรณีที่บริษัทจะไม่คุ้มครอง เนื่องจาก',
      'การป่วยที่เกิดขึ้นในระยะเวลาที่ไม่คุ้มครอง (Waiting Period) 30 วัน นับแต่วันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือวันที่บริษัทอนุมัติให้เพิ่มผลประโยชน์ของสัญญาเพิ่มเติมนี้ แล้วแต่กรณีใดจะเกิดขึ้นภายหลัง หรือ',
      [
        'การป่วยดังต่อไปนี้ ที่เกิดขึ้นในระยะเวลาที่ไม่คุ้มครอง (Waiting Period) 120 วัน นับแต่วันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือวันที่บริษัทอนุมัติให้เพิ่มผลประโยชน์ของสัญญาเพิ่มเติมนี้ แล้วแต่กรณีใดจะเกิดขึ้นภายหลัง',
        [
          'เนื้องอก ถุงน้ำ หรือมะเร็งทุกชนิด',
          'ไส้เลื่อนทุกชนิด',
          'การตัดทอนซิล หรืออดีนอยด์',
          'เส้นเลือดขอดที่ขา',
          'ริดสีดวงทวาร',
          'ต้อเนื้อ หรือต้อกระจก',
          'นิ่วทุกชนิด',
          'เยื่อบุโพรงมดลูกเจริญผิดที่',
        ],
      ],
      [
        'สภาพที่เป็นมาก่อนการเอาประกันภัย (Pre-existing Condition)',
        'บริษัทจะไม่จ่ายผลประโยชน์ตามสัญญาเพิ่มเติมนี้ สำหรับโรคเรื้อรัง การบาดเจ็บ หรือการป่วย (รวมถึงภาวะแทรกซ้อน) ที่ยังมิได้รักษาให้หายก่อนวันที่สัญญาเพิ่มเติมนี้เริ่มมีผลคุ้มครองเป็นครั้งแรก เว้นแต่',
        [
          'ผู้เอาประกันภัยได้แถลงให้บริษัททราบ และบริษัทยินยอมรับความเสี่ยงภัย โดยไม่มีเงื่อนไขยกเว้นความคุ้มครองดังกล่าว หรือ',
          'โรคเรื้อรัง การบาดเจ็บ หรือการป่วย (รวมถึงภาวะแทรกซ้อน) นั้น ไม่ปรากฏอาการ ไม่ได้รับการตรวจรักษาหรือวินิจฉัยโดยแพทย์ หรือไม่ได้พบหรือปรึกษาแพทย์ ในระยะ 5 ปี ก่อนวันที่สัญญาเพิ่มเติมเริ่มมีผลคุ้มครองเป็นครั้งแรก และในช่วงเวลา 3 ปี ตั้งแต่วันที่สัญญาเพิ่มเติมนี้เริ่มมีผลคุ้มครองเป็นครั้งแรก',
        ],
      ],
      'ข้อยกเว้นทั่วไป',
      [
        'ข้อยกเว้นสัญญาเพิ่มเติมค่ารักษาพยาบาล ไอเฮลท์ตี้ อัลตร้า (MHP) มีทั้งหมด 21 ข้อ ตัวอย่างเช่น',
        'การประกันภัยนี้ไม่คุ้มครองค่าใช้จ่ายจากการรักษาพยาบาล หรือความเสียหายที่เกิดจากการบาดเจ็บหรือการป่วย (รวมทั้งภาวะแทรกซ้อน) อาการ หรือภาวะความผิดปกติที่เกิดจาก',
        [
          'ภาวะที่เป็นผลจากความผิดปกติที่เกิดขึ้นแต่กำเนิด หรือระบบการสร้างอวัยวะของร่างกายไม่สมบูรณ์แต่กำเนิด หรือโรคทางพันธุกรรม หรือความผิดปกติในการพัฒนาการของร่างกาย เว้นแต่ สัญญาเพิ่มเติมนี้มีผลคุ้มครองมาไม่น้อยกว่า 1 ปี และปรากฏอาการหลังผู้เอาประกันภัยมีอายุครบ 16 ปีบริบูรณ์',
          'การตรวจรักษาหรือการผ่าตัดเพื่อเสริมสวย หรือการแก้ไขปัญหาผิวพรรณ สิว ฝ้า กระ รังแค ผมร่วงหรือการควบคุมน้ำหนักตัว การผ่าตัดที่สามารถทดแทนด้วยการรักษาแนวทางอื่น เว้นแต่เป็นการตกแต่งบาดแผลอันเนื่องมาจากอุบัติเหตุที่ได้รับความคุ้มครอง',
          'โรคเอดส์ หรือกามโรค หรือโรคติดต่อทางเพศสัมพันธ์',
          'การฆ่าตัวตาย การพยายามฆ่าตัวตาย การทำร้ายร่างกายตนเอง หรือการพยายามทำร้ายร่างกายตนเองไม่ว่าจะเป็นการกระทำโดยตนเอง หรือยินยอมให้ผู้อื่นกระทำไม่ว่าจะอยู่ในระหว่างวิกลจริตหรือไม่ก็ตาม ทั้งนี้รวมถึงอุบัติเหตุจากการที่ผู้เอาประกันภัย กิน ดื่ม หรือฉีดยาหรือสารมีพิษเข้าร่างกาย การใช้ยาเกินกว่าที่แพทย์สั่ง',
          'การบาดเจ็บที่เกิดขึ้นอันเป็นผลมาจากการกระทำของผู้เอาประกันภัย',
        ],
        [
          'ขณะอยู่ภายใต้ฤทธิ์สารเสพติด หรือยาเสพติดให้โทษจนไม่สามารถครองสติได้ หรือ',
          'ขณะอยู่ภายใต้ฤทธิ์สุราโดยมีระดับแอลกอฮอล์ในร่างกายขณะตรวจเทียบเท่ากับระดับแอลกอฮอล์ในเลือด ตั้งแต่ 150 มิลลิกรัมเปอร์เซ็นต์ขึ้นไป หรือ',
          'ขณะอยู่ภายใต้ฤทธิ์สุราจนไม่สามารถครองสติได้ ในกรณีที่ไม่มีการตรวจวัดหรือในกรณีที่ไม่สามารถตรวจวัด ระดับแอลกอฮอล์ได้',
        ],
      ],
    ],
  },
  EXCEPTION_NOTED_MCI: {
    title: 'เงื่อนไขที่สำคัญ และข้อยกเว้นสำหรับสัญญาเพิ่มเติมค่ารักษาพยาบาล โรคร้ายโซชิลด์ (MCI)',
    exceptions: [
      'เงื่อนไขที่สำคัญ กรณีที่บริษัทจะไม่คุ้มครอง เนื่องจาก',
      'ผู้เอาประกันภัยฉ้อฉลประกันภัย',
      'การเจ็บป่วยด้วยโรคร้ายแรงที่เกิดขึ้นในระยะเวลาที่ไม่คุ้มครอง (Waiting Period) 90 วัน นับแต่วันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือวันที่บริษัทอนุมัติให้เพิ่มผลประโยชน์ของสัญญาเพิ่มเติมนี้ แล้วแต่กรณีใดจะเกิดขึ้นภายหลัง',
      [
        'สภาพที่เป็นมาก่อนการเอาประกันภัย (Pre-existing Condition)',
        'บริษัทจะไม่จ่ายผลประโยชน์ตามสัญญาเพิ่มเติมนี้ สำหรับโรคเรื้อรัง การบาดเจ็บ หรือการป่วย (รวมถึงภาวะแทรกซ้อน) ที่ยังมิได้รักษาให้หายก่อนวันที่สัญญาเพิ่มเติมนี้เริ่มมีผลคุ้มครองเป็นครั้งแรก เว้นแต่',
        [
          'ผู้เอาประกันภัยได้แถลงให้บริษัททราบ และบริษัทยินยอมรับความเสี่ยงภัย โดยไม่มีเงื่อนไขยกเว้นความคุ้มครองดังกล่าว หรือ',
          'โรคเรื้อรัง การบาดเจ็บ หรือการป่วย (รวมถึงภาวะแทรกซ้อน) นั้น ไม่ปรากฏอาการ ไม่ได้รับการตรวจรักษาหรือวินิจฉัยโดยแพทย์ หรือไม่ได้พบหรือปรึกษาแพทย์ ในระยะ 5 ปี ก่อนวันที่สัญญาเพิ่มเติมเริ่มมีผลคุ้มครองเป็นครั้งแรก และในช่วงเวลา 3 ปี ตั้งแต่วันที่สัญญาเพิ่มเติมนี้เริ่มมีผลคุ้มครองเป็นครั้งแรก',
        ],
      ],
      'ข้อยกเว้นทั่วไป',
      [
        'ข้อยกเว้นสัญญาเพิ่มเติมค่ารักษาพยาบาล โรคร้ายโซชิลด์ (MCI) มีทั้งหมด 21 ข้อ ตัวอย่างเช่น',
        'การประกันภัยนี้ไม่คุ้มครองค่าใช้จ่ายจากการรักษาพยาบาล หรือความเสียหายที่เกิดจากการบาดเจ็บหรือการป่วย (รวมทั้งภาวะแทรกซ้อน) อาการ หรือภาวะความผิดปกติที่เกิดจาก',
        [
          'ภาวะที่เป็นผลจากความผิดปกติที่เกิดขึ้นแต่กำเนิด หรือระบบการสร้างอวัยวะของร่างกายไม่สมบูรณ์แต่กำเนิด หรือโรคทางพันธุกรรม หรือความผิดปกติในการพัฒนาการของร่างกาย เว้นแต่ สัญญาเพิ่มเติมนี้มีผลคุ้มครองมาไม่น้อยกว่า 1 ปี และปรากฏอาการหลังผู้เอาประกันภัยมีอายุครบ 16 ปีบริบูรณ์',
          'การตรวจรักษาหรือการผ่าตัดเพื่อเสริมสวย หรือการแก้ไขปัญหาผิวพรรณ สิว ฝ้า กระ รังแค ผมร่วงหรือการควบคุมน้ำหนักตัว การผ่าตัดที่สามารถทดแทนด้วยการรักษาแนวทางอื่น เว้นแต่เป็นการตกแต่งบาดแผลอันเนื่องมาจากอุบัติเหตุที่ได้รับความคุ้มครอง',
          'โรคเอดส์ หรือกามโรค หรือโรคติดต่อทางเพศสัมพันธ์',
          'การฆ่าตัวตาย การพยายามฆ่าตัวตาย การทำร้ายร่างกายตนเอง หรือการพยายามทำร้ายร่างกายตนเองไม่ว่าจะเป็นการกระทำโดยตนเอง หรือยินยอมให้ผู้อื่นกระทำไม่ว่าจะอยู่ในระหว่างวิกลจริตหรือไม่ก็ตาม ทั้งนี้รวมถึงอุบัติเหตุจากการที่ผู้เอาประกันภัย กิน ดื่ม หรือฉีดยาหรือสารมีพิษเข้าร่างกาย การใช้ยาเกินกว่าที่แพทย์สั่ง',
          'การตรวจสุขภาพ การร้องขอเข้าอยู่รักษาตัวในสถานพยาบาล หรือร้องขอการผ่าตัด การพักฟื้น หรือการพักเพื่อการฟื้นฟู หรือการรักษาโดยวิธีให้พักอยู่เฉย ๆ หรือการพักรักษาตัวในสถานพยาบาล เพื่อให้มีผู้ช่วยดูแลทั่วไป การตรวจหรือการรักษาที่ไม่เกี่ยวข้องกับโรคที่เป็นสาเหตุของการรับตัวไว้ในสถานพยาบาล การตรวจวินิจฉัยการบาดเจ็บหรือการป่วย การรักษาหรือตรวจวิเคราะห์เพื่อหาสาเหตุ ซึ่งไม่ใช่ความจำเป็นทางการแพทย์ หรือไม่เป็นมาตรฐานทางการแพทย์',
        ],
      ],
      'คำเตือน',
      [
        'คำเตือนสำหรับสัญญาเพิ่มเติมค่ารักษาพยาบาล โรคร้ายโซชิลด์ (MCI)',
        [
          'ความคุ้มครองค่ารักษาพยาบาลจากโรคร้ายแรงภายใต้สัญญาเพิ่มเติมและบันทึกสลักหลังที่แนบท้ายสัญญาเพิ่มเติมนี้ จะเป็นไปตามคำนิยามโรคร้ายแรงและข้อกำหนดทั่วไปของสัญญาเพิ่มเติมฉบับนี้ ซึ่งอาจแตกต่างไปจากสัญญาเพิ่มเติมโรคร้ายแรงแบบอื่นๆ ทั้งนี้ กรุณาศึกษารายละเอียดในเอกสารเสนอขายนี้',
          'สัญญาเพิ่มเติมนี้ มีผลประโยชน์ค่ารักษาพยาบาลจากโรคร้ายแรงสูงสุดต่อรอบปีกรมธรรม์ประกันภัย และผลประโยชน์ค่ารักษาพยาบาลจากโรคร้ายแรงสูงสุดตลอดอายุของผู้เอาประกันภัยที่มีการรับประกันภัยนี้ วงเงินสูงสุดตามที่ระบุในตารางผลประโยชน์ในกรมธรรม์ประกันภัยที่บริษัทออกให้',
          'บริษัทมีสิทธิปรับเบี้ยประกันภัยตามอายุ และขั้นอาชีพ ของแต่ละบุคคล หรือตามค่าใช้จ่ายในการรักษาพยาบาลที่สูงขึ้น หรือจากประสบการณ์การจ่ายค่าสินไหมทดแทนโดยรวมของพอร์ตโฟลิโอ (Portfolio) ของสัญญาเพิ่มเติมนี้ ตามที่ได้รับความเห็นชอบจากนายทะเบียน',
          'ผู้ขอเอาประกันภัยควรตรวจสอบรายละเอียดผลประโยชน์คุ้มครองและเงื่อนไขต่างๆ ของกรมธรรม์ประกันภัยนี้ทันทีเมื่อได้รับกรมธรรม์',
        ],
      ],
    ],
  },
  EXPLANATION_NOTED_MCI: {
    title: 'คำนิยามโรคร้ายแรงของสัญญาเพิ่มเติมค่ารักษาพยาบาล โรคร้ายโซชิลด์ (MCI)',
    explanations: [
      'โรคร้ายแรงที่ให้ความคุ้มครองภายใต้สัญญาเพิ่มเติมค่ารักษาพยาบาล โรคร้ายโซชิลด์',
      [
        'โรคมะเร็ง (Cancer) หมายถึง การเกิดขึ้นของเนื้องอกหรือเซลล์ที่ได้รับการตรวจยืนยันทางพยาธิวิทยาว่าเป็นมะเร็ง ทั้งนี้ ไม่รวมถึง',
        [
          'มะเร็งผิวหนังทุกชนิด (Any Skin Cancers) ยกเว้นมะเร็งผิวหนังเมลาโนมาชนิดร้ายแรง (Malignant Melanoma)',
          'กลุ่มเนื้องอกชนิด Borderline หรือ กลุ่มเนื้องอกที่มีโอกาสเป็นมะเร็งน้อย (Low Malignant Potential) ยกเว้น กลุ่มเนื้องอกชนิด Borderline Tumor (Low malignant potential) ของรังไข่',
          'เนื้องอกที่ผลทางพยาธิวิทยาจัดเป็นเนื้องอกระยะก่อนเป็นมะเร็ง (Pre-Malignant) เช่น CIN I  CIN II  CIN III',
          'มะเร็งในผู้ป่วยที่ติดเชื้อเอชไอวี',
        ],
        'โรคหลอดเลือดสมองที่ได้รับการรักษาโดยวิธีใส่สายสวนเส้นเลือดบริเวณคอ (Stroke Treatment by Carotid Angioplasty and Stent Placement) หมายถึง การใส่สายสวนเข้าทางเส้นเลือดแดง และใส่อุปกรณ์ค้ำหลอดเลือด (Stent) ในเส้นเลือด Carotid Artery เพื่อการรักษาหรือป้องกันผู้เอาประกันภัยที่เคยได้รับการวินิจฉัยภาวะโรคหลอดเลือดสมองขาดเลือดมาก่อน ซึ่งต้องกระทำภายใต้ข้อบ่งชี้ทางเวชปฏิบัติมาตรฐานปัจจุบันโดยแพทย์ผู้เชี่ยวชาญที่มีใบอนุญาตในสาขาที่เหมาะสม',
        'โรคหลอดเลือดสมองโป่งพองที่ต้องรักษาโดยการผ่าตัด (Cerebral Aneurysm Requiring Brain Surgery) หมายถึง การเข้ารับการผ่าตัดสมองด้วยวิธีการเปิดกะโหลกศีรษะ (Craniotomy) เพื่อหนีบ ซ่อมแซม หรือนำเส้นโลหิตแดงส่วนที่โป่งพอง (Aneurysm) ออก การวินิจฉัยต้องยืนยันด้วยเทคนิคการถ่ายภาพที่เหมาะสมของหลอดเลือดสมอง และต้องได้รับการรักษาโดยประสาทศัลยแพทย์ (Neurosurgeon)\nทั้งนี้ ไม่รวมถึงการโป่งพองของหลอดเลือดสมองจากการติดเชื้อใด ๆ (Infection and Microtic aneurysm) การรักษาเส้นโลหิตแดงของสมองที่โป่งพองโดยวิธีใช้สายสวนทางหลอดเลือดเพื่อทำการรักษา การรักษาด้วยการตัดกะโหลกแบบจำกัด (Craniectomy) และการเจาะรูที่กะโหลก (Burr hole)',
        'โรคหลอดเลือดสมองแตกหรืออุดตัน (Major Stroke) หมายถึง การเกิดความบกพร่องทางระบบประสาทอย่างเฉียบพลัน อันมีสาเหตุมาจากโรคหลอดเลือดสมองอันเนื่องมาจากการอุดตัน (Cerebral Thrombosis) หรือการแตก (Intracerebral Haemorrhage) หรือการอุดตันโดยลิ่มเลือดจากหัวใจหรือหลอดเลือดนอกกะโหลกศีรษะ (Extracranial Embolism) การวินิจฉัยต้องยืนยันด้วยการตรวจพบการเปลี่ยนแปลงใหม่ของภาพเอกซเรย์คอมพิวเตอร์ (CT Scan) หรือภาพคลื่นแม่เหล็ก (MRI)\nทั้งนี้ ไม่รวมถึงโรคเนื้อเยื่อสมองขาดเลือด (Infarction) หรือเลือดออกในกะโหลกศีรษะ อันเนื่องจากการได้รับการบาดเจ็บภายนอกและโรคสมองขาดเลือดแบบชั่วคราว (Transient Ischemic Attack หรือ Reversible Ischemic Neurological Deficit)',
        'การผ่าตัดเส้นเลือดแดงใหญ่เอออร์ต้า (Surgery to Aorta) หมายถึง การเข้ารับการผ่าตัดใหญ่แบบเปิดหน้าอกหรือช่องท้องเพื่อซ่อมแซมหรือแก้ไขหลอดเลือดแดงใหญ่เอออร์ต้า (Aorta) บริเวณทรวงอกและช่องท้อง โดยใช้กราฟท์ (Graft) อันเนื่อง มาจากผนังหลอดเลือดแดงใหญ่โป่งพอง ตีบ อุดตัน หรือผนังด้านในแยกตัวออก (Aortic Dissection) ทั้งนี้หลอดเลือดแดงใหญ่เอออร์ต้า หมายความถึง หลอดเลือดแดงใหญ่เอออร์ต้าระดับอกและช่องท้องเท่านั้น ไม่รวมถึงแขนงต่างๆ ของหลอดเลือดแดงใหญ่เอออร์ต้า\nทั้งนี้ ไม่รวมถึง การผ่าตัดขนาดเล็ก (Minimally Invasive Surgery) หรือการใช้สายสวนเข้าสู่หลอดเลือดแดง (Intra Arterial Techniques)',
        'การผ่าตัดเส้นเลือดเลี้ยงกล้ามเนื้อหัวใจ (Coronary Artery By-pass Surgery) หมายถึง การผ่าตัดโดยการเปิดเข้าทางทรวงอก เพื่อรักษาโรคที่เกิดจากเส้นเลือดเลี้ยงกล้ามเนื้อหัวใจตีบหรือตัน โดยการตัดต่อเส้นเลือดใหม่\nทั้งนี้ ไม่รวมถึงการขยายเส้นเลือดกล้ามเนื้อหัวใจที่อุดตัน โดยวิธีการขยายหลอดเลือดหัวใจ (Angioplasty), การใส่อุปกรณ์ค้ำหลอดเลือดหัวใจ (Stent Insertion), เลเซอร์ (Laser) หรือหัตถการอื่นๆ ที่ทำในหลอดเลือดแดงหัวใจ (Other Intra-arterial procedures)',
        'โรคกล้ามเนื้อหัวใจตายเฉียบพลัน (Acute Myocardial Infarction) หมายถึง การเกิดกล้ามเนื้อหัวใจตายอย่างเฉียบพลัน โดยมีลักษณะครบทั้ง 3 ข้อดังนี้',
        [
          'มีประวัติการเจ็บหน้าอกซึ่งเป็นลักษณะเฉพาะของหัวใจขาดเลือด',
          'มีการเพิ่มขึ้นของ Cardiac Troponin (T or I อย่างน้อย 3 เท่าของค่าปกติของคนทั่วไป หรือ มีการเพิ่มขึ้นของ CKMB อย่างน้อย 2 เท่าของค่าปกติของคนทั่วไป)',
          'มีการเปลี่ยนแปลงของคลื่นไฟฟ้าหัวใจที่เกิดขึ้นใหม่และมีลักษณะจำเพาะสำหรับโรคกล้ามเนื้อหัวใจตายเฉียบพลันครั้งแรก หรือการตรวจทางรังสี หรือการตรวจอื่นๆ ที่เป็นมาตรฐานทางการแพทย์สำหรับการวินิจฉัย โรคหัวใจ ซึ่งแสดงว่าเป็นภาวะกล้ามเนื้อหัวใจตายเฉียบพลันครั้งแรก',
        ],
        'การผ่าตัดลิ้นหัวใจโดยวิธีการเปิดหัวใจ (Open Heart Surgery for the Heart Valve) หมายถึง การผ่าตัดเปิดหัวใจ (Open Heart Surgery) เพื่อเปลี่ยนหรือซ่อมแซมลิ้นหัวใจ อันมีสาเหตุมาจากความบกพร่องในการทำงานของลิ้นหัวใจ แต่ไม่รวมถึงการทำบอลลูน (Balloon) การใช้สายสวน (Catheter Techniques) หรือหัตถการที่ทำผ่านหลอดเลือดแดง (Intra-arterial procedures)',
        'โรคแรงดันในหลอด เลือดแดงปอดสูงแบบปฐมภูมิ (Primary Pulmonary Arterial Hypertension) หมายถึง โรคแรงดันในหลอดเลือดแดงปอดสูงโดยหาสาเหตุไม่ได้ เป็นเหตุให้ผนังกล้ามเนื้อหัวใจด้านขวาล่างขยายขนาดขึ้น ซึ่งตรวจวินิจฉัยโดยอายุรแพทย์โรคหัวใจ (Cardiologist) พร้อมหลักฐานการตรวจพบโดยการสวนหัวใจ (Cardiac Catheterization) ความผิดปกตินี้เป็นผลให้มีความผิดปกติของหัวใจถึงระดับ 4 อย่างถาวร ตาม The New York Heart Association (NYHA) Functional Classification\nการจัดระดับความผิดปกติของหัวใจของ The New York Heart Association (NYHA) Functional Classification หมายถึง เกณฑ์การจัดระดับความผิดปกติของหัวใจ โดยอ้างอิงจาก New York Heart Association จากสหรัฐอเมริกา ซึ่งใช้เป็นมาตรฐานสำหรับการประเมินความผิดปกติของหัวใจเมื่อเทียบกับความสามารถในการมีกิจกรรมประจำวันต่าง ๆ 4 ระดับ ดังนี้\nระดับ 1 สามารถปฏิบัติกิจวัตรประจำวันได้โดยไม่จำกัด และไม่ส่งผลให้เกิดอาการผิดปกติ เช่น เหนื่อย ใจสั่น หายใจลำบาก หรือเจ็บหน้าอก (Angina Pain)\nระดับ 2 สามารถปฏิบัติกิจวัตรประจำวันโดยมีข้อจำกัดเล็กน้อย เช่น เหนื่อย ใจสั่น หายใจลำบาก หรือเจ็บหน้าอก (Angina Pain) ซึ่งคนปกติจะไม่มีอาการดังกล่าว\nระดับ 3 สามารถปฏิบัติกิจวัตรประจำวันโดยมีข้อจำกัดอย่างมาก เมื่อมีการปฏิบัติกิจวัตรประจำวันเพียงเล็กน้อย ก็ส่งผลให้เกิดอาการผิดปกติ เช่น เหนื่อย ใจสั่น หายใจลำบาก หรือเจ็บหน้าอก (Angina Pain)\nระดับ 4 ไม่สามารถปฏิบัติกิจวัตรประจำวันใดๆ ได้เลย เนื่องจากมีอาการผิดปกติ เช่น เหนื่อย ใจสั่น หายใจลำบาก แม้ในขณะพัก',
        'การผ่าตัดเปลี่ยนอวัยวะหรือปลูกถ่ายไขกระดูก (Major Organs Transplantation or Bone Marrow Transplantation) หมายถึง การได้รับการผ่าตัดเปลี่ยนอวัยวะ หรือปลูกถ่ายไขกระดูกในฐานะผู้รับ (Recipient) ดังต่อไปนี้',
        [
          'อวัยวะในที่นี้หมายถึงเฉพาะหัวใจ ปอด ตับ ไต ตับอ่อน โดยมีสาเหตุจากการที่อวัยวะนั้นอยู่ในระยะสุดท้ายที่ไม่สามารถกลับมาทำงานได้ดังเดิม หรือ',
          'การปลูกถ่ายไขกระดูกโดยการใช้ Haematopoietic stem cells ภายหลังการ ทำ Bone Marrow Ablation',
          'ทั้งนี้ไม่รวมถึงการปลูกถ่ายสเต็มเซลล์อื่นๆ และการปลูกถ่ายอวัยวะเพียงส่วนใดส่วนหนึ่ง',
        ],
      ],
      'โรคร้ายแรงสำหรับเด็กที่ให้ความคุ้มครองภายใต้สัญญาเพิ่มเติมค่ารักษาพยาบาล โรคร้ายโซชิลด์ (ผู้เอาประกันภัยที่มีอายุระหว่าง 1 เดือน – 10 ปี)',
      [
        'โรคเบาหวานในเด็ก ชนิดที่ 1 (Juvenile Diabetes Mellitus Type 1) หมายถึง โรคเบาหวานในเด็กและวัยรุ่นที่เกิดจากเซลล์เบต้าของตับอ่อนถูกทำลาย ทำให้ไม่สามารถผลิตอินซูลินได้ ต้องได้รับการรักษาโดยการฉีดอินซูลินเท่านั้น ผู้ป่วยโรคนี้จะมีอาการกระหายน้ำ ดื่มน้ำบ่อย (polydipsia) การปัสสาวะบ่อย (polyuria) อยากอาหารเพิ่มขึ้น น้ำหนักลดลง ระดับอินซูลินในเลือดต่ำ มีภาวะเลือดเป็นกรดในบางครั้ง โดยบริษัทจะจ่ายผลประโยชน์ภายใต้เงื่อนไข 2 ข้อดังต่อไปนี้',
        [
          'ได้รับการวินิจฉัยว่าเป็นโรคนี้จากแพทย์ผู้เชี่ยวชาญทางด้านต่อมไร้ท่อ และ',
          'ระหว่างการเข้าพักรักษาตัวในโรงพยาบาลหลังจากได้รับการวินิจฉัย จะต้องได้รับการฉีดอินซูลินเป็นประจำทุกวัน เพื่อควบคุมการเผาผลาญของน้ำตาลกลูโคส\nทั้งนี้ ไม่คุ้มครองโรคเบาหวานชนิดที่ 2 (Type II DM)',
        ],
        'โรคคาวาซากิ (Kawasaki Diseases) หมายถึง โรคในเด็กที่เกิดอย่างเฉียบพลัน มีไข้สูง ร่วมกับโรคหลายระบบ คือ มีการอักเสบของหลอดเลือดแดงขนาดกลางทั่วร่างกาย รวมถึงหลอดเลือดที่ไปเลี้ยงหัวใจและกล้ามเนื้อหัวใจ ต่อมน้ำเหลืองบริเวณคอโตและอักเสบโดยไม่มีหนอง มีผื่นที่เยื่อบุและผิวหนัง การวินิจฉัยต้องได้รับการยืนยันจากกุมารแพทย์ หรือแพทย์ผู้เชี่ยวชาญโรคหัวใจ และผลการตรวจหัวใจด้วยคลื่นเสียงสะท้อนความถี่สูง พบหลอดเลือดหัวใจโป่งพองโดยมีเส้นผ่าศูนย์กลางอย่างน้อย 5 มิลลิเมตร หลังจากการป่วยเฉียบพลัน',
        'ไข้รูห์มาติกและลิ้นหัวใจรั่ว (Rheumatic Fever with Valvular Impairment) หมายถึง ไข้รูห์มาติกเฉียบพลันที่ได้รับการยืนยันจากกุมารแพทย์ตามเกณฑ์การวินิจฉัยของ Jones criteria ฉบับปรับปรุงใหม่ โดยมีความเสียหายของลิ้นหัวใจตั้งแต่หนึ่งลิ้นขึ้นไปอันเนื่องมาจากไข้รูห์มาติกซึ่งต้องได้รับการยืนยันจากการตรวจสอบการทำงานของ\nลิ้นหัวใจเชิงปริมาณโดยแพทย์ผู้เชี่ยวชาญเฉพาะโรคหัวใจ',
        'โรคพิษสุนัขบ้า (Rabies) หมายถึง โรคติดเชื้อจากสุนัข แมว และสัตว์อื่นๆ ที่สามารถแพร่สู่คนผ่านการกัดจากสัตว์ที่ติดเชื้อ ซึ่งจะต้องแสดงหลักฐานของอาการดังต่อไปนี้',
        [
          'มีอาการกลืนลำบาก มีน้ำลายปริมาณมาก กลัวน้ำ และเกิดภาพหลอน และ',
          'ตรวจพบสารกระตุ้นแอนติบอด่ี้ของไวรัสพิษสุนัขบ้า หรือ แอนติบอด่ี้ไวรัสพิษสุนัขบ้าในน้ำไขสันหลัง (CSF)',
          'การวินิจฉัยจะต้องได้รับการรับรองโดยแพทย์ผู้เชี่ยวชาญในสาขาที่เกี่ยวข้อง',
        ],
      ],
    ],
  },
  EXCEPTION_NOTED_CIES: {
    title: 'ข้อยกเว้นทั่วไปของสัญญาเพิ่มเติมคุ้มครองโรคร้ายแรงและบันทึกสลักหลังฯ (CI 123)',
    exceptions: [
      'ข้อยกเว้นทั่วไป',
      [
        'ตัวอย่างข้อยกเว้นสัญญาเพิ่มเติมคุ้มครองโรคร้ายแรงและบันทึกสลักหลังฯ (CI 123)',
        'สัญญาเพิ่มเติมฉบับนี้ไม่คุ้มครองการเจ็บป่วยด้วยโรคร้ายแรง ดังต่อไปนี้',
        [
          'กรณีเจ็บป่วยด้วยโรคร้ายแรง เว้นแต่การสูญเสียการดำรงชีพอย่างอิสระ ซึ่งเกิดขึ้นโดยทางตรงหรือทางอ้อม ทั้งหมดหรือแต่บางส่วน อันเนื่องมาจากสาเหตุดังต่อไปนี้',
          [
            'ความผิดปกติซึ่งแพทย์ยืนยันและมีหลักฐานชัดเจนว่าเกี่ยวข้องกับโรคร้ายแรงหรือโรคร้ายแรงที่เกิดขึ้นก่อนวันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือก่อนวันที่ให้มีการต่ออายุสัญญาเมื่อสัญญาเพิ่มเติมสิ้นผลบังคับ (Reinstatement) หรือก่อนวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัยของสัญญาเพิ่มเติมนี้ แล้วแต่วันใดจะเกิดขึ้นภายหลัง ทั้งนี้ ในกรณีที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย บริษัทจะไม่คุ้มครองเฉพาะในส่วนของจำนวนเงินเอาประกันภัยที่เพิ่มขึ้นเท่านั้น เว้นแต่ ผู้เอาประกันภัย ได้แถลงให้บริษัททราบและบริษัทยินยอมรับความเสี่ยงภัย โดยไม่มีเงื่อนไขยกเว้นความคุ้มครองดังกล่าว',
            'การฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง หรือพยายามกระทำเช่นว่านั้น',
            'สูดดม กิน ดื่ม ฉีด หรือนำสารมีพิษเข้าร่างกายไม่ว่าด้วยวิธีใด ในขณะที่รู้สึกผิดชอบ หรือ วิกลจริต หรือไม่ก็ตาม',
            'ผู้เอาประกันภัยปฏิเสธไม่ยอมรับการรักษา แนะนำ หรือ ปฏิบัติตามคำแนะนำของแพทย์',
          ],
          'กรณีสูญเสียการดำรงชีพอย่างอิสระ อันเนื่องมาจากสาเหตุดังต่อไปนี้',
          [
            'การฆ่าตัวตาย พยายามฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง',
            'การบาดเจ็บขณะที่ผู้เอาประกันภัยก่ออาชญากรรมที่มีความผิดสถานหนัก หรือขณะถูกจับกุม หรือหลบหนีการจับกุม',
          ],
          'กรณีภาวะวิกฤต จะไม่ครอบคลุมถึงภาวะหรือโรคใด ๆ ที่เกิดขึ้นโดยตรงหรือโดยอ้อม ทั้งหมดหรือบางส่วน จากเหตุการณ์ใดเหตุการณ์หนึ่งดังต่อไปนี้',
          [
            'การฆ่าตัวตาย การพยายามฆ่าตัวตาย การทำร้ายร่างกายตนเอง หรือการพยายามทำร้ายร่างกายตนเองไม่ว่าจะเป็นการกระทำโดยตนเอง หรือยินยอมให้ผู้อื่นกระทำไม่ว่าจะอยู่ในระหว่างวิกลจริตหรือไม่ก็ตาม ทั้งนี้รวมถึงอุบัติเหตุจากการที่ผู้เอาประกันภัย กิน ดื่ม หรือฉีดยาหรือสารมีพิษเข้าร่างกาย การใช้ยาเกินกว่าที่แพทย์สั่ง',
            'การรักษาหรือการบำบัดการติดยาเสพติดให้โทษ บุหรี่ สุรา หรือสารออกฤทธิ์ต่อจิตประสาท',
          ],
        ],
      ],
      'คำเตือน',
      [
        'คำเตือนสำหรับสัญญาเพิ่มเติมคุ้มครองโรคร้ายแรงและบันทึกสลักหลังฯ (CI 123)',
        [
          'บริษัทอาจปรับเบี้ยประกันภัย ณ วันครบรอบปีกรมธรรม์ประกันภัย อันเนื่องมาจากอายุ และ/หรือ ขั้นอาชีพ ของแต่ละบุคคล หรือจาก\nประสบการณ์การจ่ายสินไหมทดแทนโดยรวมของพอร์ตโฟลิโอ (Portfolio) ของสัญญาเพิ่มเติมนี้ ตามที่นายทะเบียนได้ให้ความเห็นชอบแล้ว',
          'ความคุ้มครองโรคร้ายแรงภายใต้สัญญาเพิ่มเติมและบันทึกสลักหลังที่แนบท้ายสัญญาเพิ่มเติมนี้ เป็นไปตามคำนิยามโรคร้ายแรงและข้อกำหนดทั่วไปของกรมธรรม์ประกันภัยฉบับนี้ กรุณาศึกษารายละเอียดในเอกสารเสนอขาย และ/หรือ กรมธรรม์ประกันภัยที่บริษัทออกให้',
          'ผู้ขอเอาประกันภัยควรตรวจสอบรายละเอียดผลประโยชน์คุ้มครองและเงื่อนไขต่างๆ ของกรมธรรม์ประกันภัยนี้ทันทีเมื่อได้รับกรมธรรม์',
        ],
      ],
      'หมายเหตุ: สัญญาเพิ่มเติมคุ้มครองโรคร้ายแรง สามารถต่ออายุได้ถึงอายุ 98 ปี ทั้งนี้ ต้องไม่เกินระยะเวลาเอาประกันภัยของกรมธรรม์ประกันชีวิตที่สัญญาเพิ่มเติมนี้แนบท้ายอยู่',
      'เงื่อนไขที่สำคัญ',
      [
        'ระยะเวลาที่ไม่คุ้มครอง (Waiting Period) สัญญาเพิ่มเติมคุ้มครองโรคร้ายแรงและบันทึกสลักหลังนี้จะไม่คุ้มครองการป่วยด้วยโรคร้ายแรง หรือความผิดปกติซึ่งแพทย์ยืนยันและมีหลักฐานชัดเจนว่าเกี่ยวข้องกับโรคร้ายแรงที่ได้รับความคุ้มครองภายใต้สัญญาเพิ่มเติมนี้ ที่เกิดขึ้นภายใน 90 วัน นับแต่วันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือหากมีการต่ออายุสัญญาเมื่อสัญญาเพิ่มเติมสิ้นผลบังคับ (Reinstatement) ให้นับแต่วันเริ่มมีผลคุ้มครองตามการต่ออายุครั้งสุดท้าย หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัยของสัญญาเพิ่มเติมนี้ แล้วแต่วันใดจะเกิดขึ้นภายหลัง ทั้งนี้ ในกรณีที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย บริษัทจะไม่คุ้มครองเฉพาะในส่วนของจำนวน\nเงินเอาประกันภัยที่เพิ่มขึ้นเท่านั้น',
        'ยกเว้น กรณีอุบัติเหตุภายใต้ผลประโยชน์ภาวะวิกฤติที่ไม่มีระยะเวลาที่ไม่คุ้มครอง',
      ],
    ],
  },
  EXPLANATION_NOTED_CIES: {
    title: 'คำนิยามโรคร้ายแรงของสัญญาเพิ่มเติมค่ารักษาพยาบาล โรคร้ายโซชิลด์ (MCI)',
    explanations: [
      'ผลประโยชน์จากสัญญาเพิ่มเติมคุ้มครองโรคร้ายแรงและบันทึกสลักหลังฯ (CI 123)*',
      [
        'ผลประโยชน์ความคุ้มครองโรคร้ายแรงระยะรุนแรง (Major Stage Critical Illness)',
        [
          'เมื่อบริษัทมีการจ่ายผลประโยชน์ความคุ้มครองในข้อนี้เป็นที่เรียบร้อยแล้ว ผลประโยชน์ความคุ้มครองอื่นใดที่มีอยู่ในข้อ 1.2, 1.3, 2.1, 2.2, 2.3  เป็นอันสิ้นสุด และบริษัทจะคืนเบี้ยประกันภัยให้แก่ผู้เอาประกันภัยสำหรับส่วนที่ยังไม่ได้ให้ความคุ้มครองให้แก่ผู้เอาประกันภัย เว้นแต่ผู้เอาประกันภัยได้รับผลประโยชน์ดังกล่าวนั้นแล้ว ในกรณีที่ผู้เอาประกันภัยได้รับผลประโยชน์ความคุ้มครองกรณีภาวะวิกฤตในข้อ 1.2 ไปแล้ว จำนวนเงินเอาประกันภัยสำหรับความคุ้มครองโรคร้ายแรงระยะรุนแรงในข้อนี้ จะถูกปรับลดลง ซึ่งจะคำนวณจากจำนวนเงินเอาประกันภัย หักด้วย สินไหมทดแทนสำหรับความคุ้มครองกรณีภาวะวิกฤตที่จ่ายไปแล้ว โดยบริษัทจะคืนเบี้ยประกันภัยสำหรับความคุ้มครองโรคร้ายแรงระยะรุนแรง ให้แก่ผู้เอาประกันภัยตามสัดส่วนสำหรับระยะเวลาที่ยังไม่ได้รับความคุ้มครอง และจำนวนเงินเอาประกันภัยที่ลดลง และเบี้ยประกันภัยงวดถัดไปสำหรับความคุ้มครองโรคร้ายแรงระยะรุนแรงจะถูกปรับลดลง ตามจำนวนเงินเอาประกันภัยที่ลดลงดังกล่าว',
        ],
        'ผลประโยชน์ความคุ้มครองกรณีภาวะวิกฤต (Critical Care Benefit)',
        [
          'หากผู้เอาประกันภัยมีการป่วยหรือบาดเจ็บ จนทำให้เกิดเหตุการณ์ใดเหตุการณ์หนึ่ง ดังต่อไปนี้',
          '- การเข้ารับการรักษาในหอผู้ป่วยหนัก (ICU) ที่ต้องใช้เครื่องพยุงชีวิตขั้นสูงเป็นเวลาอย่างน้อย 5 วันติดต่อกัน',
          '- การไม่สามารถปฏิบัติกิจวัตรประจำวันได้ด้วยตนเองอย่างถาวร ตั้งแต่ 2 อย่างขึ้นไป',
          'เมื่อบริษัทมีการจ่ายผลประโยชน์ความคุ้มครองในข้อนี้เป็นที่เรียบร้อยแล้ว ผลประโยชน์ความคุ้มครองในข้อ 1.2 นี้เป็นอันสิ้นสุด',
        ],
        'ผลประโยชน์ความคุ้มครองโรคร้ายแรงสำหรับเด็ก (Juvenile Critical Illness)',
        [
          'สำหรับผู้เอาประกันภัยอายุตั้งแต่ 1 เดือน - 18 ปี',
          'เมื่อบริษัทมีการจ่ายผลประโยชน์ความคุ้มครองในข้อนี้เป็นที่เรียบร้อยแล้ว ผลประโยชน์ความคุ้มครองในข้อ 1.3 นี้เป็นอันสิ้นสุด',
        ],
      ],
      'ผลประโยชน์จากบันทึกสลักหลังแนบท้ายสัญญาเพิ่มเติม',
      [
        'ผลประโยชน์เพิ่มเติมคุ้มครองโรคร้ายแรงระยะก่อนเริ่มต้น',
        [
          'เมื่อบริษัทมีการจ่ายผลประโยชน์ความคุ้มครองในข้อนี้เป็นที่เรียบร้อยแล้ว ผลประโยชน์ความคุ้มครองในข้อ 2.1 นี้เป็นอันสิ้นสุด',
        ],
        'ผลประโยชน์เพิ่มเติมคุ้มครองโรคร้ายแรงระยะเริ่มต้นถึงปานกลาง',
        [
          'เมื่อบริษัทมีการจ่ายผลประโยชน์ความคุ้มครองในข้อนี้เป็นที่เรียบร้อยแล้ว ผลประโยชน์ความคุ้มครองในข้อ 2.2 นี้เป็นอันสิ้นสุด',
        ],
        'ผลประโยชน์เพิ่มเติมคุ้มครองโรคร้ายแรงภายใต้เงื่อนไขพิเศษ',
        [
          'เมื่อบริษัทมีการจ่ายผลประโยชน์ความคุ้มครองในข้อนี้เป็นที่เรียบร้อยแล้ว ผลประโยชน์ความคุ้มครองในข้อ 2.3 นี้เป็นอันสิ้นสุด',
        ],
      ],
      'หมายเหตุ: * สัญญาเพิ่มเติมนี้มีระยะเวลาเอาประกันภัย 1 ปี บริษัทอาจปรับเบี้ยประกันภัย ณ วันครบรอบปีกรมธรรม์ประกันภัย อันเนื่องมาจากอายุ และ/หรือ ขั้นอาชีพ ของแต่ละบุคคล หรือจากประสบการณ์การจ่ายสินไหมทดแทนโดยรวมของพอร์ตโฟลิโอ (Portfolio) ของสัญญาเพิ่มเติมนี้ ตามที่นายทะเบียนได้ให้ความเห็นชอบแล้ว',
    ],
  },
  DISEASE_NOTED_CIES: {
    title: 'รายชื่อโรคร้ายแรงภายใต้สัญญาเพิ่มเติมโรคร้ายแรง',
    diseases: [
      'โรคร้ายแรงระยะรุนแรง (Major Stage Critical Illness)',
      [
        'โรคสมองเสื่อมชนิดอัลไซเมอร์',
        'โรคโลหิตจางจากไขกระดูกไม่สร้างเม็ดโลหิต',
        'โรคเยื่อหุ้มสมองและไขสันหลังอักเสบจากเชื้อแบคทีเรีย',
        'เนื้องอกในสมอง ชนิดที่ไม่ใช่มะเร็ง',
        'ตาบอด',
        'โรคมะเร็งระยะลุกลาม',
        'โรคกล้ามเนื้อหัวใจ',
        'ตับวาย',
        'โรคหลอดลมปอดอุดกั้นเรื้อรังขั้นรุนแรง / โรคปอดระยะสุดท้าย',
        'ภาวะโคม่า',
        'การผ่าตัดเส้นเลือดเลี้ยงกล้ามเนื้อหัวใจ',
        'กล้ามเนื้อหัวใจตายเฉียบพลันจากการขาดเลือด',
        'การผ่าตัดลิ้นหัวใจโดยวิธีการเปิดหัวใจ',
        'ไตวายเรื้อรัง',
        'การสูญเสียการได้ยิน',
        'กลุ่มอาการไอเซนเมนเกอร์',
        'ภาวะลิ้นหัวใจติดเชื้อ',
        'การสูญเสียความสามารถในการพูด',
        'แผลไหม้ฉกรรจ์',
        'การบาดเจ็บที่ศีรษะอย่างรุนแรง',
        'การผ่าตัดเปลี่ยนอวัยวะหรือปลูกถ่ายไขกระดูก',
        'โรคของเซลล์ประสาทควบคุมการเคลื่อนไหว',
        'โรคระบบประสาทมัลติเพิล สะเคลอโรสิส',
        'โรคกล้ามเนื้อเสื่อม',
        'โรคไวรัสตับอักเสบขั้นรุนแรง',
        'โรคเส้นเลือดหัวใจตีบ',
        'อัมพาตของกล้ามเนื้อแขนหรือขา',
        'โรคพาร์กินสัน',
        'โรคแรงดันในหลอดเลือดแดงปอดสูงแบบปฐมภูมิ',
        'ภาวะข้ออักเสบรูมาตอยด์ชนิดรุนแรง',
        'โรคหลอดเลือดสมองแตกหรืออุดตัน',
        'การผ่าตัดเส้นเลือดแดงใหญ่เอออร์ต้า',
        'ไตอักเสบลูปูส จากโรคซิสเต็มมิค ลูปูส อิริเธมาโตซูส',
        'สมองอักเสบจากเชื้อไวรัส',
        'โรคความบกพร่องในการทำงานของต่อมหมวกไตเรื้อรัง',
        'โรคหลอดเลือดสมองโป่งพองที่ต้องรักษาโดยการผ่าตัด',
        'การฉีกขาดของรากประสาทต้นแขน',
        'โรคโปลิโอ (Poliomyelitis)',
        'การผ่าตัดกระดูกสันหลังคดที่ไม่ทราบสาเหตุ',
        'ภาวะตับอ่อนอักเสบที่กลับเป็นซ้ำและเรื้อรัง',
        'โรคเท้าช้าง',
        'โรคถุงน้ำในไต',
        'โรคเนื้อเยื่อพังผืดอักเสบติดเชื้อและเป็นเนื้อตาย',
        'โรคหนังแข็งชนิดลุกลาม',
        'โรคลำไส้อักเสบเป็นแผลรุนแรง',
        'เยื่อหุ้มสมองอักเสบจากวัณโรค',
        'โรคกล้ามเนื้ออ่อนแรง',
        'การติดเชื้อไวรัสภูมิคุ้มกันบกพร่องที่เกิดจากการเปลี่ยนถ่ายเลือด',
        'โรคครอยตส์เฟลดต์-จาค็อบ',
        'อีโบล่า',
        'ภาวะอะแพลลิก',
        'ภาวะขั้นสุดท้าย',
        'การสูญเสียการดำรงชีพอย่างอิสระ',
      ],
      'ความคุ้มครองกรณีวิกฤต (Critical Care Benefit)',
      'การป่วยหรือบาดเจ็บ จนทำให้เกิดเหตุการณ์ใดเหตุการณ์หนึ่ง ดังนี้',
      [
        'การเข้ารับการรักษาในหอผู้ป่วยหนัก (ICU) ที่ต้องใช้เครื่องพยุงชีวิตขั้นสูง* เป็นเวลาอย่างน้อย 5 วันติดต่อกัน',
        'การไม่สามารถปฏิบัติกิจวัตรประจำวันได้ด้วยตนเองอย่างถาวร ตั้งแต่ 2 อย่างขึ้นไป',
      ],
      'โรคร้ายแรงสำหรับเด็ก (Juvenile Critical Illness) คุ้มครองตั้งแต่ผู้เอาประกันภัยมีอายุ 1 เดือน - 18 ปี',
      [
        'ไข้รูห์มาติกและลิ้นหัวใจรั่ว',
        'โรคคาวาซากิ (Kawasaki Diseases)',
        'โรคมือเท้าปากมีอาการซับซ้อนรุนแรง',
        'โรคไข้เลือดออกที่เกิดจากการติดเชื้อไวรัสเดงกี่ชนิดรุนแรง ',
        'โรคเบาหวานชนิดที่ต้องพึ่งอินซูลิน ',
        'โรควิลสัน',
        'โรคไตอักเสบและมีกลุ่มอาการไตเนโฟรติก',
        'โรคกระดูกเปราะที่เป็นกรรมพันธุ์',
        'โรคฮีโมฟีเลีย A และโรคฮีโมฟีเลีย B',
        'โรคกล้ามเนื้ออ่อนแรงชนิดที่ 1',
        'โรคข้ออักเสบเรื้อรังที่พบในเด็ก',
        'ภาวะบกพร่องทางสติปัญญาที่เกิดจากโรคหรือการบาดเจ็บ',
        'โรคอัลไซเมอร์เด็ก',
        'ภาวะพร่องเอนไซม์แต่กำเนิดที่มีหน้าที่ในการสังเคราะห์กรดน้ำดี',
        'ภาวะขาดเอนไซม์ไพรูเวตดีไฮโดรจีเนส',
        'โรคทางพันธุกรรมที่ส่งผลกระทบต่อโครงสร้างกระดูกและพัฒนาการของร่างกาย',
        'โรคบาดทะยักชนิดที่มีอาการรุนแรง',
      ],
    ],
  },
  DISEASE_ADDITIONAL_NOTED_CIES: {
    title: 'รายชื่อโรคร้ายแรงภายใต้บันทึกสลักหลังที่แนบท้ายสัญญาเพิ่มเติมโรคร้ายแรง',
    diseases: [
      'โรคร้ายแรงระยะก่อนเริ่มต้น (Pre-Early Stage Critical Illness)',
      [
        'เนื้องอกที่มีลักษณะ ไม่ใช่มะเร็งเต็มขั้น แต่มีศักยภาพในการพัฒนาไปเป็นมะเร็ง',
        'ความบกพร่องทางสายตาจากจอประสาทตาเสื่อมจากอายุ',
        'ภาวะสูญเสียการได้ยินจากอายุ',
        'การตัดเท้าข้างหนึ่งเนื่องจากภาวะแทรกซ้อนจากโรคเบาหวาน',
        'โรคไตจากเบาหวาน',
        'ภาวะเบาหวานขึ้นจอประสาทตา',
      ],
      'โรคร้ายแรงระยะเริ่มต้นถึงปานกลาง (Early to Intermediate Stage Critical Illness)',
      [
        'การใส่เครื่องกระตุ้นหัวใจ',
        'การผ่าตัดเอาเนื้องอกต่อมใต้สมองออก',
        'การผ่าตัดตับ',
        'การผ่าตัดบายพาสหลอดเลือดหัวใจโคโรนารี่ โดยการทำคีย์โฮลล์',
        'โรคมะเร็งระยะไม่ลุกลาม',
        'โรคลูปัส หรือ โรคเอสแอลอีระยะรุนแรงปานกลาง',
        'แผลไหม้ฉกรรจ์ชนิดรุนแรงปานกลาง',
        'การปลูกถ่ายลำไส้เล็ก หรือการปลูกถ่ายกระจกตา',
        'โรคหลอดเลือดสมองที่ได้รับการรักษาโดยวิธีใส่สายสวนเส้นเลือดบริเวณคอ',
        'โรคระบบประสาทมัลติเพิลสะเคลอโรสิสระยะแรก',
        'การผ่าตัดลิ้นหัวใจผ่านทางผิวหนัง',
        'โรคหลอดเลือดหัวใจตีบที่รักษาด้วยการสวนหลอดเลือดหัวใจ',
        'โรคโปลิโอขั้นร้ายแรงปานกลาง',
        'โรคหนังแข็งชนิดลุกลามระยะแรก',
        'โรคหอบหืดรุนแรงเฉียบพลัน',
        'การผ่าตัดเล็กของเส้นเลือดแดงใหญ่เอออร์ต้า',
        'การใส่เครื่องกระตุ้นหัวใจถาวร',
        'เส้นประสาทตาฝ่อและความสามารถในการมองเห็นต่ำ',
        'โรคกล้ามเนื้อเสื่อมปานกลางถึงรุนแรง',
        'การผ่าตัดเอาปอดออกหนึ่งข้าง',
        'มะเร็งระยะไม่ลุกลามของอวัยวะเฉพาะส่วนที่ได้รับการผ่าตัดอวัยวะนั้นออกจากร่างกายทั้งหมด',
        'การผ่าตัดเลาะเยื่อหุ้มหัวใจ',
        'โรคกล้ามเนื้อหัวใจชนิดที่มีกล้ามเนื้อหนา และ โรคกล้ามเนื้อหัวใจชนิดที่มีกล้ามเนื้อแข็งตัวมากกว่าปกติ',
        'ภาวะเลือดจางชนิดจากไขกระดูกฝ่อที่สามารถกลับเป็นปกติได้',
        'การผ่าตัดเนื้องอกที่ต่อมหมวกไต',
        'โรคไตวายระยะแรก',
        'ภาวะตับอ่อนที่มีเนื้อตับอ่อนตายเฉียบพลัน',
        'การใส่ตะแกรงกรองลิ่มเลือด',
        'การผ่าตัดฟื้นฟูทางเดินน้ำดี',
        'โรคแรงดันปอดสูงแบบทุติยภูมิ',
        'โรคตับแข็ง',
        'โรคหนังแข็งชนิดลุกลามที่มีอาการเครสซินโดรม',
        'การสูญเสียการมองเห็นของตาหนึ่งข้าง',
        'โรคหลอดเลือดสมองโป่งพองที่รักษาโดยใช้ขดลวดผ่านสายสวนทางหลอดเลือด',
        'การผ่าตัดเลือดคั่งใต้เยื่อหุ้มสมอง',
        'อาการบาดเจ็บที่ไขสันหลัง',
        'ภาวะสูญเสียการทำงานของกล้ามเนื้อแขนหรือขาหนึ่งข้าง',
        'โรคหลอดเลือดสมองที่ต้องได้รับการผ่าตัดลอกหลอดเลือดแดงคาโรติค',
        'การสูญเสียการได้ยินบางส่วน หรือ การผ่าตัดภาวะโพรง Cavernous อุดตัน',
        'การผ่าตัดฝังประสาทหูเทียม',
        'การใส่สายระบายน้ำไขสันหลังในสมอง',
        'โรคทางระบบประสาทที่ส่งผลต่อการเคลื่อนไหว, การทรงตัว และการควบคุมการเคลื่อนไหวของดวงตา',
      ],
      'โรคร้ายแรงภายใต้เงื่อนไขพิเศษ (Special Critical Illness)',
      [
        'ภาวะสมองเสื่อมระดับกลาง',
        'การรักษาหัวใจเต้นผิดจังหวะ',
        'การผ่าตัดแก้ไขภาวะผนังกั้นหัวใจพิการแต่กำเนิด',
        'การผ่าตัดเนื้องอกที่ต่อมหมวกไต',
      ],
      'หมายเหตุ (*) เครื่องพยุงชีวิตขั้นสูง หมายถึง เครื่องช่วยหายใจแบบสอดท่อหรือเจาะคอ (MV) หรือเครื่องพยุงการทำงานของหัวใจ และปอด (ECMO)',
    ],
  },
  EXCEPTION_NOTED_FH: {
    title: '',
    exceptions: [
      '(*) สัญญาเพิ่มเติมเป็นสัญญาประกันภัยที่มีระยะเวลาเอาประกันภัย 1 ปี อัตราเบี้ยประกันภัยอาจมีการปรับเพิ่มหรือลดได้ และเงื่อนไขความคุ้มครองอาจเปลี่ยนแปลงได้',
      '(**) ทั้งนี้ไม่รวมถึงการบาดเจ็บ, โรคหัวใจ, โรคมะเร็ง, ไตวาย หรือการรักษาในค่าห้องผู้ป่วยวิกฤต',
      '(***) ผลประโยชน์นี้จำกัดใช้ได้ 1 ครั้งในช่วงชีวิตของผู้เอาประกันภัย',
    ],
    condition: '',
  },
  EXCEPTION_NOTED_ESCI: {
    title: '',
    exceptions: [
      'ข้อยกเว้นสัญญาเพิ่มเติม โรคร้ายแรงคุ้มครองเริ่มต้น (ESCI) มีทั้งหมด 9 ข้อ เช่น',
      'ไม่คุ้มครองการเจ็บป่วยด้วยโรคร้ายแรง อันเนื่องมาจากสาเหตุ ดังต่อไปนี้',
      [
        'โรคร้ายแรงที่เกิดขึ้น ก่อนวันเริ่มมีผลบังคับของสัญญาเพิ่มเติมฉบับนี้ หรือก่อนวันต่ออายุสัญญาเพิ่มเติมครั้งนี้ครั้งสุดท้าย หรือก่อนวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัยของสัญญาเพิ่มเติมนี้ แล้วแต่วันใดจะเกิดขึ้นภายหลัง',
        'ผู้เอาประกันภัยปฏิเสธไม่ยอมรับการรักษา แนะนำ หรือ ปฏิบัติตามคำแนะนำของแพทย์',
        'การติดเชื้อไวรัสภูมิคุ้มกันบกพร่อง (HIV Positive) หรือภาวะของโรคภูมิคุ้มกันบกพร่อง (AIDS) ของผู้เอาประกันภัย',
        'การบริจาคอวัยวะร่างกาย โดยผู้เอาประกันภัยเป็นผู้บริจาคอวัยวะของตนเองให้แก่ผู้อื่น',
        'การดื่มสุรา หรือการใช้ยาในทางที่ผิด (Drug abuse) ที่เป็นสาเหตุโดยตรงและโดยอ้อมให้เกิดการเจ็บป่วย หรือการสูญเสียภาวะการทำงานของอวัยวะหรือกล้ามเนื้อ',
      ],
    ],
    condition: '',
  },
  EXCEPTION_NOTED_WPE: {
    title: '',
    exceptions: [
      'ข้อยกเว้นสัญญาเพิ่มเติมผลประโยชน์ยกเว้นเบี้ยประกันภัยสัญญาหลัก เนื่องจากโรคร้ายแรง 2020 (WPE2020) มีทั้งหมด 6 ข้อ เช่น',
      'ไม่คุ้มครองการเจ็บป่วยด้วยโรคร้ายแรง อันเนื่องมาจากสาเหตุ ดังต่อไปนี้',
      [
        'โรคร้ายแรงที่เกิดขึ้น ก่อนวันเริ่มมีผลบังคับของสัญญาเพิ่มเติมฉบับนี้ หรือก่อนวันต่ออายุสัญญาเพิ่มเติมครั้งนี้ครั้งสุดท้าย หรือก่อนวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัยของสัญญาเพิ่มเติมนี้ แล้วแต่วันใดจะเกิดขึ้นภายหลัง',
        'การติดเชื้อไวรัสภูมิคุ้มกันบกพร่อง (HIV Positive) หรือภาวะของโรคภูมิคุ้มกันบกพร่อง (AIDS) ของผู้เอาประกันภัย',
        'การตรวจรักษาพยาบาลที่ผู้เอาประกันภัย ซึ่งเป็นแพทย์สั่งให้แก่ตัวเอง รวมทั้งการตรวจรักษาพยาบาลจากแพทย์ ผู้ซึ่งเป็น บิดา มารดา คู่สมรส หรือบุตรของผู้เอาประกันภัย',
        'ผู้เอาประกันภัยปฏิเสธไม่ยอมรับการรักษา แนะนำ หรือ ปฏิบัติตามคำแนะนำของแพทย์',
        'การฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง หรือพยายามกระทำเช่นว่านั้น',
      ],
    ],
    condition: '',
  },
  EXCEPTION_NOTED_DCI: {
    title: '',
    exceptions: [
      'ข้อยกเว้นสัญญาเพิ่มเติมเสียชีวิตและโรคร้ายแรง (DCI) มีทั้งหมด 16 ข้อ เช่น',
      'ไม่คุ้มครองการทุพพลภาพ อันเนื่องมาจากสาเหตุ ดังต่อไปนี้',
      [
        'การฆ่าตัวตาย พยายามฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง',
        'ความบกพร่องทางร่างกาย การเจ็บป่วย หรือบาดเจ็บ ที่ผู้เอาประกันภัยทราบอยู่แล้วในขณะที่ทำสัญญาประกันภัย แต่มิได้แจ้งให้บริษัททราบ',
        [
          'การบาดเจ็บที่เกิดขึ้นจากการกระทำของผู้เอาประกันภัย อันเกิดจากหรือสืบเนื่องจากสาเหตุภายใต้เงื่อนไขข้อหนึ่งข้อใดดังต่อไปนี้',
          [
            '- ขณะอยู่ภายใต้ฤทธิ์สารเสพติด หรือยาเสพติดให้โทษจนไม่สามารถครองสติได้ หรือ',
            '- ขณะอยู่ภายใต้ฤทธิ์สุรา โดยมีระดับแอลกอฮอล์ในร่างกายขณะตรวจ เทียบเท่ากับระดับแอลกอฮอล์ในเลือดตั้งแต่ 150 มิลลิกรัมเปอร์เซ็นต์ขึ้นไป หรือขณะอยู่ภายใต้ฤทธิ์สุราจนไม่สามารถครองสติได้ ในกรณีที่ไม่มีการตรวจวัดหรือในกรณีที่ไม่สามารถตรวจวัดระดับแอลกอฮอล์ได้',
          ],
        ],
        'การบาดเจ็บขณะที่ผู้เอาประกันภัยปฏิบัติหน้าที่เป็นทหาร ตำรวจ หรืออาสาสมัคร และเข้าปฏิบัติการในสงคราม หรือปราบปราม',
        'การบาดเจ็บขณะที่ผู้เอาประกันภัยขับขี่หรือปฏิบัติหน้าที่เป็นพนักงานประจำอากาศยานใดๆ',
      ],
      'ไม่คุ้มครองการเจ็บป่วยด้วยโรคร้ายแรง อันเนื่องมาจากสาเหตุ ดังต่อไปนี้',
      [
        'การฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง',
        'ความผิดปกติซึ่งแพทย์ยืนยันและมีหลักฐานชัดเจนว่าเกี่ยวข้องกับโรคร้ายแรงหรือโรคร้ายแรงที่เกิดขึ้นก่อนวันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้',
        'การติดเชื้อไวรัสภูมิคุ้มกันบกพร่อง (HIV Positive) หรือภาวะของโรคภูมิคุ้มกันบกพร่อง (AIDS) ของผู้เอาประกันภัย',
        'ผู้เอาประกันภัยปฏิเสธไม่ยอมรับการรักษา แนะนำ หรือ ปฏิบัติตามคำแนะนำของแพทย์',
        'เสพยาเสพติด หรือสุราเกินขนาด',
      ],
    ],
    condition: '',
  },
  EXCEPTION_NOTED_MEB: {
    title: '',
    exceptions: [
      'สัญญาเพิ่มเติมนี้จะไม่สามารถออกให้กับผู้มีภูมิลำเนาหรืออาศัยอยู่ภายนอกราชอาณาจักร',
      'บริษัทฯ สงวนสิทธิ์ในการรับประกันภัยผู้ที่มีสิทธิ์เบิกค่ารักษาพยาบาล หรือได้รับความคุ้มครองภายใต้ประกันสุขภาพอื่นๆอยู่แล้ว',
    ],
    condition: '',
  },

  EXCEPTION_NOTED_MEB_17: {
    title: '',
    exceptions: [
      'ข้อยกเว้นสัญญาเพิ่มเติมค่าชดเชยรายวัน (MEB) มีทั้งหมด 17 ข้อ เช่น',
      [
        'สัญญาเพิ่มเติมนี้ไม่คุ้มครองการรักษาพยาบาล หรือความเสียหายที่เกิดจากการบาดเจ็บหรือเจ็บป่วย (รวมทั้งโรคแทรกซ้อน) อาการ หรือภาวะความผิดปกติที่เกิดจาก',
        [
          'โรคเรื้อรัง การเจ็บป่วยหรือการบาดเจ็บที่ยังมิได้รักษาให้หายก่อนวันทำสัญญาประกันภัย การตรวจรักษาภาวะที่เป็นมาแต่กำเนิด (Congenital) หรือปัญหาด้านพัฒนาการ หรือโรคทางพันธุกรรม',
          'การตรวจรักษาหรือการผ่าตัดเพื่อเสริมสวย หรือการแก้ไขปัญหาผิวพรรณ สิว ฝ้า กระ รังแค ผมร่วง หรือการควบคุมน้ำหนักตัว หรือการผ่าตัดอันมีลักษณะเลือกได้ เว้นแต่เป็นการตกแต่งบาดแผลอันเนื่องมาจากอุบัติเหตุที่ได้รับความคุ้มครอง',
          'การตั้งครรภ์ แท้งบุตร ทำแท้ง การคลอดบุตร โรคแทรกซ้อนจากการตั้งครรภ์ การแก้ไขปัญหาการมีบุตรยาก (รวมถึงการสืบวิเคราะห์และการรักษา) การทำหมันหรือการคุมกำเนิด',
          'โรคเอดส์ หรือกามโรค หรือโรคติดต่อทางเพศสัมพันธ์',
          'การตรวจรักษา หรือการป้องกัน การใช้ยา หรือสารต่างๆ เพื่อการชะลอความเสื่อมของวัย หรือการให้ฮอร์โมนทดแทนในวัยใกล้หมดหรือหมดระดู การเสื่อมสมรรถภาพทางเพศในหญิงหรือชาย การรักษาความผิดปกติทางเพศ และการแปลงเพศ',
        ],
      ],
    ],
    condition: '',
  },

  EXCEPTION_NOTED_MEK: {
    title: 'เงื่อนไขและข้อยกเว้นที่สำคัญสำหรับสัญญาเพิ่มเติมค่ารักษาพยาบาล (พิเศษ) สำหรับเด็ก “สมาร์ท เมดิแคร์ คิดส์”',
    exceptions: [
      'เงื่อนไขทั่วไป',
      'การเจ็บป่วยใดๆที่เกิดขึ้นในระยะเวลา 30 วันนับจากวันที่ทำสัญญาเพิ่มเติมนี้ หรือวันต่ออายุกรณีสัญญาเพิ่มเติมสิ้นผลบังคับครั้งสุดท้าย แล้วแต่กรณีใดจะเกิดขึ้นหลังสุด',
      [
        'สำหรับการเจ็บป่วยดังต่อไปนี้ ที่เกิดขึ้นในระยะเวลา 120 วันนับจากวันทำสัญญาเพิ่มเติมนี้ หรือวันต่ออายุกรณีสัญญาเพิ่มเติมสิ้นผลบังคับครั้งสุดท้าย แล้วแต่กรณีใดจะเกิดขึ้นหลังสุด',
        [
          'เนื้องอก ถุงน้ำ หรือมะเร็งทุกชนิด',
          'ไส้เลื่อนทุกชนิด',
          'การตัดทอนซิล หรืออดีนอยด์',
          'เส้นเลือดขอดที่ขา',
          'ริดสีดวงทวาร',
          'ต้อเนื้อ หรือต้อกระจก',
          'นิ่วทุกชนิด',
          'เยื่อบุโพรงมดลูกเจริญผิดที่',
        ],
      ],
      'ข้อยกเว้น* มีทั้งหมด 26 ข้อ เช่น',
      [
        'สัญญาเพิ่มเติมนี้ไม่คุ้มครองการรักษาพยาบาล หรือความเสียหายที่เกิดจากการบาดเจ็บหรือเจ็บป่วย (รวมทั้งโรคแทรกซ้อน) อาการ หรือภาวะความผิดปกติที่เกิดจาก',
        [
          'โรคเรื้อรัง การเจ็บป่วยหรือการบาดเจ็บที่ยังมิได้รักษาให้หายก่อนวันทำสัญญาประกันภัย การตรวจรักษาภาวะที่เป็นมาแต่กำเนิด (Congenital) หรือปัญหาด้านพัฒนาการ หรือโรคทางพันธุกรรม',
          'การตรวจรักษาหรือการผ่าตัดเพื่อเสริมสวย หรือการแก้ไขปัญหาผิวพรรณ สิว ฝ้า กระ รังแค ผมร่วง หรือการควบคุมน้ำหนักตัว หรือการผ่าตัดอันมีลักษณะเลือกได้ เว้นแต่เป็นการตกแต่งบาดแผลอันเนื่องมาจากอุบัติเหตุที่ได้รับความคุ้มครอง',
          'การตั้งครรภ์ แท้งบุตร ทำแท้ง การคลอดบุตร โรคแทรกซ้อนจากการตั้งครรภ์ การแก้ไขปัญหาการมีบุตรยาก (รวมถึงการสืบวิเคราะห์และการรักษา) การทำหมันหรือการคุมกำเนิด',
          'โรคเอดส์ หรือกามโรค หรือโรคติดต่อทางเพศสัมพันธ์',
          'การตรวจรักษา หรือการป้องกัน การใช้ยา หรือสารต่างๆ เพื่อการชะลอความเสื่อมของวัย หรือการให้ฮอร์โมนทดแทนในวัยใกล้หมดหรือหมดระดู การเสื่อมสมรรถภาพทางเพศในหญิงหรือชาย การรักษาความผิดปกติทางเพศ และการแปลงเพศ',
        ],
      ],
    ],
    condition: 'หมายเหตุ * เฉพาะข้อยกเว้นบางรายการ ท่านสามารถศึกษารายละเอียดข้อยกเว้นทั้งหมดได้ในเล่มกรมธรรม์',
  },

  EXCEPTION_NOTED_MEH: {
    title: '',
    exceptions: [
      'การเจ็บป่วยใดๆที่เกิดขึ้นในระยะเวลา 30 วันนับจากวันที่ทำสัญญาเพิ่มเติมนี้ หรือวันต่ออายุกรณีสัญญาเพิ่มเติมสิ้นผลบังคับครั้งสุดท้าย แล้วแต่กรณีใดจะเกิดขึ้นหลังสุด',
      [
        'สำหรับการเจ็บป่วยดังต่อไปนี้ ที่เกิดขึ้นในระยะเวลา 120 วันนับจากวันทำสัญญาเพิ่มเติมนี้ หรือวันต่ออายุกรณีสัญญาเพิ่มเติมสิ้นผลบังคับครั้งสุดท้าย แล้วแต่กรณีใดจะเกิดขึ้นหลังสุด',
        [
          'เนื้องอก ถุงน้ำ หรือมะเร็งทุกชนิด',
          'ไส้เลื่อนทุกชนิด',
          'การตัดทอนซิล หรืออดีนอยด์',
          'เส้นเลือดขอดที่ขา',
          'ริดสีดวงทวาร',
          'ต้อเนื้อ หรือต้อกระจก',
          'นิ่วทุกชนิด',
          'เยื่อบุโพรงมดลูกเจริญผิดที่',
        ],
      ],
      'โรคเรื้อรัง การเจ็บป่วยหรือการบาดเจ็บที่ยังมิได้รักษาให้หายก่อนวันทำสัญญาประกันภัย การตรวจรักษาภาวะที่เป็นมาแต่กำเนิด หรือปัญหาด้านพัฒนาการ หรือโรคทางพันธุกรรม',
      'โรคเอดส์ หรือ กามโรค หรือโรคติดต่อทางเพศสัมพันธ์',
    ],
    condition: 'หมายเหตุ * เฉพาะข้อยกเว้นบางรายการ โปรดศึกษารายละเอียดข้อยกเว้นทั้งหมดในกรมธรรม์',
  },

  EXCEPTION_NOTED_MEH_32: {
    title: 'เงื่อนไขและข้อยกเว้นที่สำคัญสำหรับสัญญาเพิ่มเติมค่ารักษาพยาบาล',
    exceptions: [
      'เงื่อนไขทั่วไป',
      'การเจ็บป่วยใดๆที่เกิดขึ้นในระยะเวลา 30 วันนับจากวันเริ่มมีผลคุ้มครองของสัญญาเพิ่มเติมนี้ หรือวันต่ออายุกรณีสัญญาเพิ่มเติมสิ้นผลบังคับครั้งสุดท้าย แล้วแต่กรณีใดจะเกิดขึ้นหลังสุด หรือ',
      [
        'สำหรับการเจ็บป่วยดังต่อไปนี้ ที่เกิดขึ้นในระยะเวลา 120 วันนับจากวันเริ่มมีผลคุ้มครองของสัญญาเพิ่มเติมนี้ หรือวันต่ออายุ กรณีสัญญาเพิ่มเติมสิ้นผลบังคับครั้งสุดท้าย แล้วแต่กรณีใดจะเกิดขึ้นหลังสุด',
        [
          'เนื้องอก ถุงน้ำ หรือมะเร็งทุกชนิด',
          'ไส้เลื่อนทุกชนิด',
          'การตัดทอนซิล หรืออดีนอยด์',
          'เส้นเลือดขอดที่ขา',
          'ริดสีดวงทวาร',
          'ต้อเนื้อ หรือต้อกระจก',
          'นิ่วทุกชนิด',
          'เยื่อบุโพรงมดลูกเจริญผิดที่',
        ],
      ],
      'ข้อยกเว้น* มีทั้งหมด 32 ข้อ เช่น',
      [
        'สัญญาเพิ่มเติมนี้ไม่คุ้มครอง ค่าใช้จ่ายการรักษาพยาบาลหรือความเสียหายที่เกิดจากการบาดเจ็บหรือเจ็บป่วย (รวมทั้งโรคแทรกซ้อน) อาการ หรือ ภาวะความผิดปกติที่เกิดจาก',
        [
          'โรคเรื้อรัง การเจ็บป่วยหรือการบาดเจ็บที่ยังมิได้รักษาให้หายก่อนวันทำสัญญาประกันภัย การตรวจรักษาภาวะที่เป็นมาแต่กำเนิด (Congenital) หรือปัญหาด้านพัฒนาการ หรือโรคทางพันธุกรรม',
          'การตรวจรักษาหรือการผ่าตัดเพื่อเสริมสวย หรือการแก้ไขปัญหาผิวพรรณ สิว ฝ้า กระรังแค ผมร่วง หรือการควบคุมน้ำหนักตัว หรือการผ่าตัดอันมีลักษณะเลือกได้ เว้นแต่เป็นการตกแต่งบาดแผลอันเนื่องมาจาก อุบัติเหตุที่ได้รับความคุ้มครอง',
          'โรคเอดส์ หรือกามโรค หรือโรคติดต่อทางเพศสัมพันธ์',
          'การรักษาพยาบาลเชิงป้องกันโรค',
          'การตรวจรักษา หรือการป้องกัน การใช้ยา หรือสารต่าง ๆ เพื่อการชะลอความเสื่อมของวัย หรือการให้ฮอร์โมนทดแทนในวัยใกล้หมด\nหรือหมดระดู การเสื่อมสมรรถสภาพทางเพศในหญิง หรือชาย การรักษาความผิดปกติทางเพศ และการแปลงเพศ',
        ],
      ],
    ],
    condition: 'หมายเหตุ * เฉพาะข้อยกเว้นบางรายการ ท่านสามารถศึกษารายละเอียดข้อยกเว้นทั้งหมดได้ในกรมธรรม์',
  },

  EXCEPTION_NOTED_WP: {
    title: 'ไม่คุ้มครองการทุพพลภาพ อันเนื่องมาจากสาเหตุ ดังต่อไปนี้',
    exceptions: [
      'ข้อยกเว้นสัญญาเพิ่มเติมผลประโยชน์ยกเว้นเบี้ยประกันภัย (WP) มีทั้งหมด 3 ข้อ ได้แก่',
      [
        'การฆ่าตัวตาย การทำร้ายร่างกายตนเอง',
        'การปฏิบัติการทางทหารในขณะที่มีสงคราม ไม่ว่าจะประกาศหรือไม่ก็ตาม หรือขณะที่ปฏิบัติตามคำสั่งให้ปฏิบัติการเยี่ยงสงคราม หรือพิทักษ์ความสงบเรียบร้อยของบ้านเมือง',
        'อุบัติเหตุที่เกิดแก่อากาศยานใด ๆ ซึ่งผู้เอาประกันภัยเป็นผู้ขับขี่ หรืออยู่ในอากาศยานนั้น เว้นแต่ ผู้เอาประกันภัยเป็นผู้โดยสารผู้หนึ่ง หรือเป็นเจ้าหน้าที่ของสายการบินซึ่งอยู่ในอากาศยานที่ได้ประกอบการโดยสายการบินพาณิชย์รับขนส่งโดยสารตามตารางบินโดยสารในเส้นทางที่ได้กำหนดไว้',
      ],
    ],
    condition: '',
  },

  EXCEPTION_NOTED_WPTPD: {
    title: 'ไม่คุ้มครองการทุพพลภาพถาวรสิ้นเชิง ที่เกิดขึ้นอันสืบเนื่องมาจากสาเหตุหรือภาวะแทรกซ้อนดังต่อไปนี้',
    exceptions: [
      'ข้อยกเว้นสัญญาเพิ่มเติมดับบลิวพี ฟิต (WPTPD) มีทั้งหมด 9 ข้อ เช่น',
      [
        'การฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง หรือพยายามกระทำเช่นว่านั้น',
        'การบาดเจ็บขณะที่ผู้เอาประกันภัยก่ออาชญากรรมที่มีความผิดสถานหนัก หรือขณะถูกจับกุม หรือหลบหนีการจับกุม',
        'การบาดเจ็บขณะที่ผู้เอาประกันภัยกำลังขึ้นหรือกำลังลง หรือโดยสารอยู่ในอากาศยานที่มิได้จดทะเบียนเพื่อบรรทุกผู้โดยสาร และมิได้ประกอบการโดยสายการบินพาณิชย์',
        'การบาดเจ็บขณะที่ผู้เอาประกันภัยขับขี่หรือปฏิบัติหน้าที่เป็นพนักงานประจำอากาศยานใดๆ',
        'การบาดเจ็บขณะที่ผู้เอาประกันภัยปฏิบัติหน้าที่เป็น ทหาร ตำรวจ หรืออาสาสมัคร และเข้าปฏิบัติการในสงคราม หรือปราบปราม',
        'ความบกพร่องทางร่างกาย การป่วย หรือบาดเจ็บ ที่เกี่ยวข้องกับการทุพพลภาพที่แพทย์ยืนยันและมีหลักฐานชัดเจน ซึ่งผู้เอาประกันภัยทราบอยู่แล้วก่อนวันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย หรือวันต่ออายุสัญญากรณีสัญญา\nเพิ่มเติมสิ้นผลบังคับ (Reinstatement) ครั้งสุดท้าย แต่มิได้แจ้งให้บริษัททราบ เว้นแต่ ผู้เอาประกันภัย ได้แถลงให้บริษัททราบและบริษัท\nยินยอมรับความเสี่ยงภัย โดยไม่มีเงื่อนไขยกเว้นความคุ้มครองดังกล่าว',
        'การบาดเจ็บที่เกิดขึ้นจากการกระทำของผู้เอาประกันภัย อันเกิดจาก หรือสืบเนื่องจากสาเหตุภายใต้เงื่อนไขข้อหนึ่งข้อใดดังต่อไปนี้',
        [
          'ขณะอยู่ภายใต้ฤทธิ์สารเสพติด หรือยาเสพติดให้โทษจนไม่สามารถครองสติได้ หรือ',
          'ขณะอยู่ภายใต้ฤทธิ์สุรา โดยมีระดับแอลกอฮอล์ในร่างกายขณะตรวจ เทียบเท่ากับระดับแอลกอฮอล์ในเลือดตั้งแต่ 150 มิลลิกรัมเปอร์เซ็นต์\nขึ้นไป หรือ',
          'ขณะอยู่ภายใต้ฤทธิ์สุราจนไม่สามารถครองสติได้ ในกรณีที่ไม่มีการตรวจวัดหรือในกรณีที่ไม่สามารถตรวจวัดระดับแอลกอฮอล์ได้',
        ],
      ],
    ],
    condition: '',
  },

  EXCEPTION_NOTED_WPTPDCI: {
    title: 'ไม่คุ้มครองการทุพพลภาพถาวรสิ้นเชิง ที่เกิดขึ้นอันสืบเนื่องมาจากสาเหตุหรือภาวะแทรกซ้อนดังต่อไปนี้',
    exceptions: [
      'ข้อยกเว้นสัญญาเพิ่มเติมดับบลิวพี บียอนด์ (WPTPDCI) มีทั้งหมด 15 ข้อ เช่น',
      [
        'การฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง หรือพยายามกระทำเช่นว่านั้น',
        'การบาดเจ็บขณะที่ผู้เอาประกันภัยก่ออาชญากรรมที่มีความผิดสถานหนัก หรือขณะถูกจับกุม หรือหลบหนีการจับกุม',
        'การบาดเจ็บขณะที่ผู้เอาประกันภัยกำลังขึ้นหรือกำลังลง หรือโดยสารอยู่ในอากาศยานที่มิได้จดทะเบียนเพื่อบรรทุกผู้โดยสาร และมิได้ประกอบการโดยสายการบินพาณิชย์',
        'การบาดเจ็บขณะที่ผู้เอาประกันภัยขับขี่หรือปฏิบัติหน้าที่เป็นพนักงานประจำอากาศยานใดๆ',
        'การบาดเจ็บขณะที่ผู้เอาประกันภัยปฏิบัติหน้าที่เป็น ทหาร ตำรวจ หรืออาสาสมัคร และเข้าปฏิบัติการในสงคราม หรือปราบปราม',
        'ความบกพร่องทางร่างกาย การป่วย หรือบาดเจ็บ ที่เกี่ยวข้องกับการทุพพลภาพที่แพทย์ยืนยันและมีหลักฐานชัดเจน ซึ่งผู้เอาประกันภัยทราบอยู่แล้วก่อนวันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย หรือวันต่ออายุสัญญากรณีสัญญา\nเพิ่มเติมสิ้นผลบังคับ (Reinstatement) ครั้งสุดท้าย แต่มิได้แจ้งให้บริษัททราบ เว้นแต่ ผู้เอาประกันภัย ได้แถลงให้บริษัททราบและบริษัท\nยินยอมรับความเสี่ยงภัย โดยไม่มีเงื่อนไขยกเว้นความคุ้มครองดังกล่าว',
        'การบาดเจ็บที่เกิดขึ้นจากการกระทำของผู้เอาประกันภัย อันเกิดจาก หรือสืบเนื่องจากสาเหตุภายใต้เงื่อนไขข้อหนึ่งข้อใดดังต่อไปนี้',
        [
          'ขณะอยู่ภายใต้ฤทธิ์สารเสพติด หรือยาเสพติดให้โทษจนไม่สามารถครองสติได้ หรือ',
          'ขณะอยู่ภายใต้ฤทธิ์สุรา โดยมีระดับแอลกอฮอล์ในร่างกายขณะตรวจ เทียบเท่ากับระดับแอลกอฮอล์ในเลือดตั้งแต่ 150 มิลลิกรัมเปอร์เซ็นต์\nขึ้นไป หรือ',
          'ขณะอยู่ภายใต้ฤทธิ์สุราจนไม่สามารถครองสติได้ ในกรณีที่ไม่มีการตรวจวัดหรือในกรณีที่ไม่สามารถตรวจวัดระดับแอลกอฮอล์ได้',
        ],
      ],
    ],

    titleCI:
      'ไม่คุ้มครองการป่วยด้วยโรคร้ายแรงระยะรุนแรง ซึ่งเกิดขึ้นโดยทางตรงหรือทางอ้อม ทั้งหมดหรือแต่บางส่วน อันเนื่องมาจากสาเหตุดังต่อไปนี้',
    exceptionsCI: [
      [
        'ความผิดปกติซึ่งแพทย์ยืนยันและมีหลักฐานชัดเจนว่าเกี่ยวข้องกับโรคร้ายแรงหรือโรคร้ายแรงที่เกิดขึ้นก่อนวันเริ่มมีผลคุ้มครองตามสัญญา\nเพิ่มเติมนี้ หรือก่อนวันที่ให้มีการต่ออายุสัญญาเมื่อสัญญาเพิ่มเติมสิ้นผลบังคับ (Reinstatement) หรือก่อนวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงิน\nเอาประกันภัยของสัญญาเพิ่มเติมนี้ แล้วแต่วันใดจะเกิดขึ้นภายหลัง ทั้งนี้ ในกรณีที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย บริษัทจะไม่\nคุ้มครองเฉพาะในส่วนของจำนวนเงินเอาประกันภัยที่เพิ่มขึ้นเท่านั้น',
        'เว้นแต่ ผู้เอาประกันภัย ได้แถลงให้บริษัททราบและบริษัทยินยอมรับความเสี่ยงภัย โดยไม่มีเงื่อนไขยกเว้นความคุ้มครองดังกล่าว',
      ],
      'การฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง หรือพยายามกระทำเช่นว่านั้น',
      'ผู้เอาประกันภัยปฏิเสธไม่ยอมรับการรักษา แนะนำ หรือ ปฏิบัติตามคำแนะนำของแพทย์',
      'การติดเชื้อไวรัสภูมิคุ้มกันบกพร่อง (HIV Positive) หรือภาวะของโรคภูมิคุ้มกันบกพร่อง (AIDS) ของผู้เอาประกันภัย ไม่ว่าจะทางตรงหรือ\nทางอ้อมก็ตาม',
    ],
    condition: '',
  },

  EXCEPTION_NOTED_WPD01: {
    title:
      'ไม่คุ้มครองการเสียชีวิตของผู้ชำระเบี้ยประกันภัย อันเนื่องมาจากสาเหตุผู้ชำระเบี้ยประกันภัยฆ่าตัวตายภายใน 1 ปี',
    exceptions: ['ข้อยกเว้นสัญญาเพิ่มเติมผลประโยชน์มรณกรรมผู้ชำระเบี้ยประกันภัย (WPD01) มีทั้งหมด 1 ข้อ ได้แก่'],
    condition: '',
  },

  EXCEPTION_NOTED_WPDD01: {
    title: 'ไม่คุ้มครองการเสียชีวิต หรือการทุพพลภาพของผู้ชำระเบี้ยประกันภัย อันเนื่องมาจากสาเหตุ ดังต่อไปนี้',
    exceptions: [
      'ข้อยกเว้นสัญญาเพิ่มเติมผลประโยชน์ผู้ชำระเบี้ยประกันภัย (WPDD01) มีทั้งหมด 4 ข้อ ได้แก่',
      [
        'ผู้ชำระเบี้ยประกันภัยฆ่าตัวตายภายใน 1 ปี',
        'การทำร้ายร่างกายตนเอง',
        'ขณะที่ผู้เอาประกันภัยปฏิบัติหน้าที่เป็นทหาร ตำรวจ หรืออาสาสมัคร และปฏิบัติการในสงครามหรือเยี่ยงสงคราม (ไม่ว่าจะประกาศหรือไม่ก็ตาม) จลาจล เพื่อพิทักษ์ความสงบเรียบร้อยของบ้านเมือง',
        'ขณะขึ้นหรือลง หรือเป็นผู้ขับขี่ หรืออยู่ในอากาศยานใด ๆ ไม่ว่าจะขับเคลื่อนด้วยตัวของมันเองหรือไม่ก็ตามที่มิได้จดทะเบียนประกอบการบินพาณิชย์',
      ],
    ],
    condition: '',
  },

  EXCEPTION_NOTED_PBPDD_PBSDD: {
    title: 'ข้อยกเว้นสำคัญ',
    exceptions: [
      'ข้อยกเว้นสัญญาเพิ่มเติมพีบี ฟิต (PBPDD / PBSDD) มีทั้งหมด 10 ข้อ เช่น',
      [
        'ไม่คุ้มครองการเสียชีวิต อันเนื่องมาจากผู้ชำระเบี้ยประกันภัยฆ่าตัวตายด้วยใจสมัครภายในหนึ่งปี (1 ปี) นับตั้งแต่วันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือหากมีการต่ออายุสัญญาเมื่อสัญญาเพิ่มเติมสิ้นผลบังคับ (Reinstatement) ให้นับแต่วันเริ่มมีผลคุ้มครองตามการต่ออายุครั้งสุดท้าย',
      ],
      'ไม่คุ้มครองการทุพพลภาพถาวรสิ้นเชิง ที่เกิดขึ้นอันสืบเนื่องมาจากสาเหตุหรือภาวะแทรกซ้อนดังต่อไปนี้',
      [
        'การฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง หรือพยายามกระทำเช่นว่านั้น',
        'การบาดเจ็บขณะที่ผู้ชำระเบี้ยประกันภัยก่ออาชญากรรมที่มีความผิดสถานหนัก หรือขณะถูกจับกุม หรือหลบหนีการจับกุม',
        'การบาดเจ็บขณะที่ผู้ชำระเบี้ยประกันภัยกำลังขึ้นหรือกำลังลง หรือโดยสารอยู่ในอากาศยานที่มิได้จดทะเบียนเพื่อบรรทุกผู้โดยสาร  และมิได้ประกอบการโดยสายการบินพาณิชย์',
        'การบาดเจ็บขณะที่ผู้ชำระเบี้ยประกันภัยขับขี่หรือปฏิบัติหน้าที่เป็นพนักงานประจำอากาศยานใดๆ',
        'การบาดเจ็บขณะที่ผู้ชำระเบี้ยประกันภัยปฏิบัติหน้าที่เป็น ทหาร ตำรวจ หรืออาสาสมัคร และเข้าปฏิบัติการในสงคราม หรือปราบปราม',
        'ความบกพร่องทางร่างกาย การป่วย หรือบาดเจ็บ ที่เกี่ยวข้องกับการทุพพลภาพที่แพทย์ยืนยันและมีหลักฐานชัดเจน ซึ่งผู้ชำระเบี้ยประกันภัยทราบอยู่แล้วก่อนวันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย หรือวันต่ออายุสัญญากรณีสัญญาเพิ่มเติมสิ้นผลบังคับ (Reinstatement) ครั้งสุดท้าย แต่มิได้แจ้งให้บริษัททราบ เว้นแต่ ผู้ชำระเบี้ยประกันภัยได้แถลงให้บริษัททราบ\nและบริษัทยินยอมรับความเสี่ยงภัย โดยไม่มีเงื่อนไขยกเว้นความคุ้มครองดังกล่าว',
        'การบาดเจ็บที่เกิดขึ้นจากการกระทำของผู้ชำระเบี้ยประกันภัย อันเกิดจาก หรือสืบเนื่องจากสาเหตุภายใต้เงื่อนไขข้อหนึ่งข้อใดดังต่อไปนี้',
      ],
      [
        'ขณะอยู่ภายใต้ฤทธิ์สารเสพติด หรือยาเสพติดให้โทษจนไม่สามารถครองสติได้ หรือ',
        'ขณะอยู่ภายใต้ฤทธิ์สุรา โดยมีระดับแอลกอฮอล์ในร่างกายขณะตรวจ เทียบเท่ากับระดับแอลกอฮอล์ในเลือดตั้งแต่ 150 มิลลิกรัมเปอร์เซ็นต์ขึ้นไป หรือ',
        'ขณะอยู่ภายใต้ฤทธิ์สุราจนไม่สามารถครองสติได้ ในกรณีที่ไม่มีการตรวจวัดหรือในกรณีที่ไม่สามารถตรวจวัดระดับแอลกอฮอล์ได้',
      ],
    ],
    condition: '',
  },

  EXCEPTION_NOTED_PBPDDCI_PBSDDCI: {
    title: 'ข้อยกเว้นสำคัญ',
    exceptions: [
      'ข้อยกเว้นสัญญาเพิ่มเติมพีบีี บียอนด์ (PBPDDCI / PBSDDCI) มีทั้งหมด 16 ข้อ เช่น',
      [
        'ไม่คุ้มครองการเสียชีวิต อันเนื่องมาจากผู้ชำระเบี้ยประกันภัยฆ่าตัวตายด้วยใจสมัครภายในหนึ่งปี (1 ปี) นับตั้งแต่วันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือหากมีการต่ออายุสัญญาเมื่อสัญญาเพิ่มเติมสิ้นผลบังคับ (Reinstatement) ให้นับแต่วันเริ่มมีผลคุ้มครองตามการต่ออายุครั้งสุดท้าย',
      ],
      'ไม่คุ้มครองการทุพพลภาพถาวรสิ้นเชิง ที่เกิดขึ้นอันสืบเนื่องมาจากสาเหตุหรือภาวะแทรกซ้อนดังต่อไปนี้',
      [
        'การฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง หรือพยายามกระทำเช่นว่านั้น',
        'การบาดเจ็บขณะที่ผู้ชำระเบี้ยประกันภัยก่ออาชญากรรมที่มีความผิดสถานหนัก หรือขณะถูกจับกุม หรือหลบหนีการจับกุม',
        'การบาดเจ็บขณะที่ผู้ชำระเบี้ยประกันภัยกำลังขึ้นหรือกำลังลง หรือโดยสารอยู่ในอากาศยานที่มิได้จดทะเบียนเพื่อบรรทุกผู้โดยสาร  และมิได้ประกอบการโดยสายการบินพาณิชย์',
        'การบาดเจ็บขณะที่ผู้ชำระเบี้ยประกันภัยขับขี่หรือปฏิบัติหน้าที่เป็นพนักงานประจำอากาศยานใดๆ',
        'การบาดเจ็บขณะที่ผู้ชำระเบี้ยประกันภัยปฏิบัติหน้าที่เป็น ทหาร ตำรวจ หรืออาสาสมัคร และเข้าปฏิบัติการในสงคราม หรือปราบปราม',
        'ความบกพร่องทางร่างกาย การป่วย หรือบาดเจ็บ ที่เกี่ยวข้องกับการทุพพลภาพที่แพทย์ยืนยันและมีหลักฐานชัดเจน ซึ่งผู้ชำระเบี้ยประกันภัยทราบอยู่แล้วก่อนวันเริ่มมีผลคุ้มครองตามสัญญาเพิ่มเติมนี้ หรือวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย หรือวันต่ออายุสัญญากรณีสัญญาเพิ่มเติมสิ้นผลบังคับ (Reinstatement) ครั้งสุดท้าย แต่มิได้แจ้งให้บริษัททราบ เว้นแต่ ผู้ชำระเบี้ยประกันภัยได้แถลงให้บริษัททราบ\nและบริษัทยินยอมรับความเสี่ยงภัย โดยไม่มีเงื่อนไขยกเว้นความคุ้มครองดังกล่าว',
        'การบาดเจ็บที่เกิดขึ้นจากการกระทำของผู้ชำระเบี้ยประกันภัย อันเกิดจาก หรือสืบเนื่องจากสาเหตุภายใต้เงื่อนไขข้อหนึ่งข้อใดดังต่อไปนี้',
      ],
      [
        'ขณะอยู่ภายใต้ฤทธิ์สารเสพติด หรือยาเสพติดให้โทษจนไม่สามารถครองสติได้ หรือ',
        'ขณะอยู่ภายใต้ฤทธิ์สุรา โดยมีระดับแอลกอฮอล์ในร่างกายขณะตรวจ เทียบเท่ากับระดับแอลกอฮอล์ในเลือดตั้งแต่ 150 มิลลิกรัมเปอร์เซ็นต์ขึ้นไป หรือ',
        'ขณะอยู่ภายใต้ฤทธิ์สุราจนไม่สามารถครองสติได้ ในกรณีที่ไม่มีการตรวจวัดหรือในกรณีที่ไม่สามารถตรวจวัดระดับแอลกอฮอล์ได้',
      ],
      'ไม่คุ้มครองการป่วยด้วยโรคร้ายแรงระยะรุนแรง  ซึ่งเกิดขึ้นโดยทางตรงหรือทางอ้อม ทั้งหมดหรือแต่บางส่วน อันเนื่องมาจากสาเหตุดังต่อไปนี้',
      [
        'ความผิดปกติซึ่งแพทย์ยืนยันและมีหลักฐานชัดเจนว่าเกี่ยวข้องกับโรคร้ายแรงหรือโรคร้ายแรงที่เกิดขึ้นก่อนวันเริ่มมีผลคุ้มครองตามสัญญา\nเพิ่มเติมนี้ หรือก่อนวันที่ให้มีการต่ออายุสัญญาเมื่อสัญญาเพิ่มเติมสิ้นผลบังคับ (Reinstatement) หรือก่อนวันที่บริษัทอนุมัติให้เพิ่มจำนวนเงิน\nเอาประกันภัยของสัญญาเพิ่มเติมนี้ แล้วแต่วันใดจะเกิดขึ้นภายหลัง ทั้งนี้ ในกรณีที่บริษัทอนุมัติให้เพิ่มจำนวนเงินเอาประกันภัย บริษัทจะไม่คุ้มครองเฉพาะในส่วนของจำนวนเงินเอาประกันภัยที่เพิ่มขึ้นเท่านั้น\nเว้นแต่ ผู้ชำระเบี้ยประกันภัย ได้แถลงให้บริษัททราบและบริษัทยินยอมรับความเสี่ยงภัย โดยไม่มีเงื่อนไขยกเว้นความคุ้มครองดังกล่าว',
        'การฆ่าตัวตาย หรือการทำร้ายร่างกายตนเอง หรือพยายามกระทำเช่นว่านั้น',
        'ผู้ชำระเบี้ยประกันภัยปฏิเสธไม่ยอมรับการรักษา แนะนำ หรือ ปฏิบัติตามคำแนะนำของแพทย์',
        'การติดเชื้อไวรัสภูมิคุ้มกันบกพร่อง (HIV Positive) หรือภาวะของโรคภูมิคุ้มกันบกพร่อง (AIDS) ของผู้ชำระเบี้ยประกันภัย ไม่ว่าจะทางตรงหรือทางอ้อมก็ตาม',
      ],
    ],
    condition: '',
  },
}
